import React, {useContext, useEffect} from "react";
import {Prism as SyntaxHighlighter} from "react-syntax-highlighter";
import {BrandContext} from "../../common/BrandContext";
import {ScrollToPageMarker} from "../../nav/PageMarkerNavigation";
let beautify = require("js-beautify").html;

const LessonContentStyleGuide = props => {
    const brandConfig = useContext(BrandContext);
    const API_ATTR = {
        CLASS: 'Class',
        DATA: 'Data',
        ELEMENT: 'Element',
        ATTRIBUTE: 'Attribute'
    }
    const API_APPLY_TO = {
        BLOCK: 'cont-block',
        BUTTON: '<button>',
        DIV: '<div>',
    }

    useEffect(() => {
        buildDialogLinks();
        buildAccordionBlocks();
        buildToggleBlocks();
        initGlossaryLinks();
        initImageZoom();
        assignNumbering(document.getElementsByClassName('cont-base-demo')[0]);
        buildPageMarkers();
    }, []);

    function assignNumbering(element, parentNumbering, markerIdCounter = 1, parentMarkerId) {
        const children = element.children;
        let numberingCounter = 1;

        for (let i = 0; i < children.length; i++) {
            const child = children[i];
            if (child.classList.contains('js-pageMarker-viz')) {
                const numbering = parentNumbering ? parentNumbering + '.' + numberingCounter : numberingCounter;
                child.textContent = `${numbering} ${child.textContent}`;
                numberingCounter++;
                child.setAttribute('data-marker-id', markerIdCounter);
                if (parentMarkerId) child.setAttribute('data-marker-parent', parentMarkerId);
                markerIdCounter++;
            }
            if (child.classList.contains('js-group-pageMarker')) {
                const numbering = parentNumbering ? parentNumbering + '.' + (numberingCounter - 1) : numberingCounter - 1;
                assignNumbering(child, numbering, markerIdCounter, markerIdCounter - 1);
            }
        }
    }

    function getInternalLink(id) {
        const link = document.getElementById(id);
        if (link) {
            function extractNumber(element) {
                const regex = new RegExp(`page-marker-(\\d+)`);
                const matchedClass = Array.from(element.classList).find(className => regex.test(className));
                if (matchedClass) {
                    const match = matchedClass.match(regex);
                    if (match && match[1]) {
                        return parseInt(match[1]);
                    }
                }
                return null;
            }
            const handleClick = () => {
                const navigationIndex = extractNumber(link);
                ScrollToPageMarker(navigationIndex);
            }
            return <a onClick={handleClick}>{link.innerText}</a>;
        } else {
            return '';
        }
    }

    return (
        <div >
            <div className='cont-base cont-base-demo'>
                <span className='cont-head-b js-pageMarker-viz'>Text</span>
                <div className='js-group-pageMarker'>
                    <span className='cont-head-c js-pageMarker-viz'>Headings</span>
                    <p>All headings should be &lt;span&gt; elements. Heading
                        elements &lt;h1&gt;, &lt;h2&gt;, &lt;h3&gt;, &lt;h4&gt;, &lt;h5&gt;, &lt;h6&gt; should <strong>not</strong> be
                        used.</p>
                    <table className='cont-table'>
                        <tbody>
                        <tr>
                            <td>
                                <code>{'<span class="cont-head-a"></span>'}</code>
                            </td>
                            <td>
                                <span className='cont-head-a'>A heading</span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <code>{'<span class="cont-head-b"></span>'}</code>
                            </td>
                            <td>
                                <span className='cont-head-b'>B heading</span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <code>{'<span class="cont-head-c"></span>'}</code>
                            </td>
                            <td>
                                <span className='cont-head-c'>C heading</span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <code>{'<span class="cont-head-d"></span>'}</code>
                            </td>
                            <td>
                                <span className='cont-head-d'>D heading</span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <code>{'<span class="cont-head-e"></span>'}</code>
                            </td>
                            <td>
                                <span className='cont-head-e'>E heading</span>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <span className='cont-head-c js-pageMarker-viz'>Body Text</span>
                    <div className='cont-block cont-block-outlined'>
                        <div className='cont-block-body'>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt
                                ut labore et dolore magna aliqua. Urna duis convallis convallis tellus id interdum velit
                                laoreet. A pellentesque sit amet porttitor. Phasellus egestas tellus rutrum tellus
                                pellentesque eu. Ornare lectus sit amet est placerat in egestas. Non consectetur a erat
                                nam at.</p>
                        </div>
                    </div>
                    <span className='cont-head-c js-pageMarker-viz'>Lead Text</span>
                    <div className='cont-block cont-block-outlined'>
                        <div className='cont-block-body'>
                            <p className='cont-lead'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                                eiusmod tempor incididunt ut labore et dolore magna aliqua. Urna duis convallis
                                convallis tellus id interdum velit laoreet.</p>
                            <p>A pellentesque sit amet porttitor. Phasellus egestas tellus rutrum tellus pellentesque
                                eu. Ornare lectus sit amet est placerat in egestas. Non consectetur a erat nam at. Id
                                diam vel quam elementum pulvinar etiam.</p>
                        </div>
                        <SyntaxHighlighter language="html" style={{}} className={"cont-block-code"}>
                            {beautifyHTML(`
                                    <p class="cont-lead">...</p>
                                `)}
                        </SyntaxHighlighter>
                    </div>
                    <span className='cont-head-c js-pageMarker-viz'>Emphasis text</span>
                    <div className='cont-block cont-block-outlined'>
                        <div className='cont-block-body'>
                            <>
                                <p className='cont-emph'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                                    eiusmod tempor incididunt ut labore et dolore magna aliqua. Urna duis convallis
                                    convallis tellus id interdum velit laoreet.</p>
                                <p>A pellentesque sit amet porttitor. Phasellus egestas tellus rutrum tellus
                                    pellentesque eu. Ornare lectus sit amet est placerat in egestas. Non consectetur a
                                    erat nam at. Id diam vel quam elementum pulvinar etiam.</p>
                            </>
                        </div>
                        <SyntaxHighlighter language="html" style={{}} className={"cont-block-code"}>
                            {beautifyHTML(`
                                    <p class='cont-emph'>...</p>
                                `)}
                        </SyntaxHighlighter>
                    </div>
                    <span className='cont-head-c js-pageMarker-viz'>Emphasis color text</span>
                    <div className='cont-block cont-block-outlined'>
                        <div className='cont-block-body'>
                            <>
                                <p className='cont-emph-colour'>Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                                    sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Urna duis
                                    convallis convallis tellus id interdum velit laoreet.</p>
                                <p>A pellentesque sit amet porttitor. Phasellus egestas tellus rutrum tellus
                                    pellentesque eu. Ornare lectus sit amet est placerat in egestas. Non consectetur a
                                    erat nam at. Id diam vel quam elementum pulvinar etiam.</p>
                            </>
                        </div>
                        <SyntaxHighlighter language="html" style={{}} className={"cont-block-code"}>
                            {beautifyHTML(`
                                    <p class='cont-emph-colour'>...</p>
                                `)}
                        </SyntaxHighlighter>
                    </div>
                    <span className='cont-head-c js-pageMarker-viz'>Highlight text</span>
                    <div className='cont-block cont-block-outlined'>
                        <div className='cont-block-body'>
                            <>
                                <p className='cont-highlight'>Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                                    sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Urna duis
                                    convallis convallis tellus id interdum velit laoreet.</p>
                                <p>A pellentesque sit amet porttitor. Phasellus egestas tellus rutrum tellus
                                    pellentesque eu. Ornare lectus sit amet est placerat in egestas. Non consectetur a
                                    erat nam at. Id diam vel quam elementum pulvinar etiam.</p>
                            </>
                        </div>
                        <SyntaxHighlighter language="html" style={{}} className={"cont-block-code"}>
                            {beautifyHTML(`
                                    <p class="cont-highlight">...</p>
                                `)}
                        </SyntaxHighlighter>
                    </div>
                    <span className='cont-head-c js-pageMarker-viz'>Note text</span>
                    <div className='cont-block cont-block-outlined'>
                        <div className='cont-block-body'>
                            <>
                                <p className='cont-note'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                                    eiusmod tempor incididunt ut labore et dolore magna aliqua. Urna duis convallis
                                    convallis tellus id interdum velit laoreet.</p>
                                <p>A pellentesque sit amet porttitor. Phasellus egestas tellus rutrum tellus
                                    pellentesque eu. Ornare lectus sit amet est placerat in egestas.</p>
                            </>
                        </div>
                        <SyntaxHighlighter language="html" style={{}} className={"cont-block-code"}>
                            {beautifyHTML(`
                                    <p class='cont-note'>...</p>
                                `)}
                        </SyntaxHighlighter>
                    </div>
                    <span className='cont-head-c js-pageMarker-viz'>Colored Text</span>
                    <div className='cont-block cont-block-outlined'>
                        <div className='cont-block-body'>
                            <>
                                <p className="cont-colour-main">Lorem ipsum dolor sit amet</p>
                                <p className="cont-colour-custom-1">1. Lorem ipsum dolor sit amet</p>
                                <p className="cont-colour-custom-2">2. Lorem ipsum dolor sit amet</p>
                                <p className="cont-colour-custom-3">3. Lorem ipsum dolor sit amet</p>
                                <p className="cont-colour-custom-4">4. Lorem ipsum dolor sit amet</p>
                                <p className="cont-colour-custom-5">5. Lorem ipsum dolor sit amet</p>
                                <p className="cont-colour-custom-6">6. Lorem ipsum dolor sit amet</p>
                                <p className="cont-colour-custom-7">7. Lorem ipsum dolor sit amet</p>
                                <p className="cont-colour-custom-8">8. Lorem ipsum dolor sit amet</p>
                                <p className="cont-colour-custom-9">9. Lorem ipsum dolor sit amet</p>
                                <p className="cont-colour-custom-10">10. Lorem ipsum dolor sit amet</p>
                            </>
                        </div>
                        <SyntaxHighlighter language="html" style={{}} className={"cont-block-code"}>
                            {beautifyHTML(`
                                    <span class="cont-colour-main">Lorem ipsum dolor sit amet</span>
                                    <span class="cont-colour-custom-1">Lorem ipsum dolor sit amet</span>
                                    <span class="cont-colour-custom-2">Lorem ipsum dolor sit amet</span>
                                    <span class="cont-colour-custom-3">Lorem ipsum dolor sit amet</span>
                                    <span class="cont-colour-custom-4">Lorem ipsum dolor sit amet</span>
                                    <span class="cont-colour-custom-5">Lorem ipsum dolor sit amet</span>
                                    <span class="cont-colour-custom-6">Lorem ipsum dolor sit amet</span>
                                    <span class="cont-colour-custom-7">Lorem ipsum dolor sit amet</span>
                                    <span class="cont-colour-custom-8">Lorem ipsum dolor sit amet</span>
                                    <span class="cont-colour-custom-9">Lorem ipsum dolor sit amet</span>
                                    <span class="cont-colour-custom-10">Lorem ipsum dolor sit amet</span>
                                `)}
                        </SyntaxHighlighter>
                    </div>
                    <span className='cont-head-c js-pageMarker-viz'>Colored Background Text</span>
                    <div className='cont-block cont-block-outlined'>
                        <div className='cont-block-body'>
                            <>
                                <p className="cont-colour-bg-main">A pellentesque sit amet porttitor. Phasellus egestas
                                    tellus rutrum tellus pellentesque eu. Ornare lectus sit amet est placerat in
                                    egestas.</p>
                                <p className="cont-colour-bg-custom-1">Lorem ipsum dolor sit amet</p>
                                <p className="cont-colour-bg-custom-2">Lorem ipsum dolor sit amet</p>
                                <p className="cont-colour-bg-custom-3">Lorem ipsum dolor sit amet</p>
                                <p className="cont-colour-bg-custom-4">Lorem ipsum dolor sit amet</p>
                                <p className="cont-colour-bg-custom-5">Lorem ipsum dolor sit amet</p>
                                <p className="cont-colour-bg-custom-6">Lorem ipsum dolor sit amet</p>
                                <p className="cont-colour-bg-custom-7">Lorem ipsum dolor sit amet</p>
                                <p className="cont-colour-bg-custom-9">Lorem ipsum dolor sit amet</p>
                                <p className="cont-colour-bg-custom-9">Lorem ipsum dolor sit amet</p>
                                <p className="cont-colour-bg-custom-10">Lorem ipsum dolor sit amet</p>
                            </>
                        </div>
                        <SyntaxHighlighter language="html" style={{}} className={"cont-block-code"}>
                            {beautifyHTML(`
                                    <span class="cont-colour-bg-main">Lorem ipsum dolor sit amet</span>
                                    <span class="cont-colour-bg-custom-1">Lorem ipsum dolor sit amet</span>
                                    <span class="cont-colour-bg-custom-2">Lorem ipsum dolor sit amet</span>
                                    <span class="cont-colour-bg-custom-3">Lorem ipsum dolor sit amet</span>
                                    <span class="cont-colour-bg-custom-4">Lorem ipsum dolor sit amet</span>
                                    <span class="cont-colour-bg-custom-5">Lorem ipsum dolor sit amet</span>
                                    <span class="cont-colour-bg-custom-6">Lorem ipsum dolor sit amet</span>
                                    <span class="cont-colour-bg-custom-7">Lorem ipsum dolor sit amet</span>
                                    <span class="cont-colour-bg-custom-8">Lorem ipsum dolor sit amet</span>
                                    <span class="cont-colour-bg-custom-9">Lorem ipsum dolor sit amet</span>
                                    <span class="cont-colour-bg-custom-10">Lorem ipsum dolor sit amet</span>
                                `)}
                        </SyntaxHighlighter>
                    </div>
                    <span className='cont-head-c js-pageMarker-viz'>Underlined Text</span>
                    <div className='cont-block cont-block-outlined'>
                        <div className='cont-block-body'>
                            <>
                                <p className="cont-underline">Lorem ipsum dolor sit amet</p>
                            </>
                        </div>
                        <SyntaxHighlighter language="html" style={{}} className={"cont-block-code"}>
                            {beautifyHTML(`
                                    <span class="cont-underline">Lorem ipsum dolor sit amet</span>
                                `)}
                        </SyntaxHighlighter>
                    </div>
                    <span className='cont-head-c js-pageMarker-viz'>Text Alignment</span>
                    <div className='cont-block cont-block-outlined'>
                        <div className='cont-block-body'>
                            <>
                                <p className="cont-text-start">Start aligned text on all viewport sizes.</p>
                                <p className="cont-text-center">Center aligned text on all viewport sizes.</p>
                                <p className="cont-text-end">End aligned text on all viewport sizes.</p>
                            </>
                        </div>
                        <SyntaxHighlighter language="html" style={{}} className={"cont-block-code"}>
                            {beautifyHTML(`
                                    <p class="cont-text-start">Start aligned text on all viewport sizes.</p>
                                    <p class="cont-text-center">Center aligned text on all viewport sizes.</p>
                                    <p class="cont-text-end">End aligned text on all viewport sizes.</p>
                                `)}
                        </SyntaxHighlighter>
                    </div>
                    <span className='cont-head-c js-pageMarker-viz'>Vertical Alignment</span>
                    <div className='cont-block cont-block-outlined'>
                        <div className='cont-block-body'>
                            <>
                                <p className="cont-vertical-align-top">Vertical align top.</p>
                                <p className="cont-vertical-align-middle">Vertical align middle.</p>
                                <p className="cont-vertical-align-bottom">Vertical align bottom.</p>
                            </>
                        </div>
                        <SyntaxHighlighter language="html" style={{}} className={"cont-block-code"}>
                            {beautifyHTML(`
                                    <p class="cont-vertical-align-top">Vertical align top.</p>
                                    <p class="cont-vertical-align-middle">Vertical align middle.</p>
                                    <p class="cont-vertical-align-bottom">Vertical align bottom.</p>
                                `)}
                        </SyntaxHighlighter>
                    </div>
                </div>
                <span className='cont-head-b js-pageMarker-viz'>Links</span>
                <div className='js-group-pageMarker'>
                    <span className='cont-head-c js-pageMarker-viz'>Content Links</span>
                    <p>The data-tab attribute is optional in the lesson link.</p>
                    <div className='cont-block cont-block-outlined'>
                        <div className='cont-block-body'>
                            <>
                                <p><a className='cont-link-lesson' data-lesson-id='242278' data-tab='questions'>Lesson
                                    Link</a></p>
                                <p><a className='cont-link-section' data-lesson-id='242278' data-section-id='242278'>Section
                                    Link</a></p>
                                <p><a className='cont-link-tab' data-tab='questions'>Tab Link</a></p>
                            </>
                        </div>
                        <SyntaxHighlighter language="html" style={{}} className={"cont-block-code"}>
                            {beautifyHTML(`
                                    <a class="cont-link-lesson" data-lesson-id="242278" data-tab="questions">Lesson Link</a>
                                    <a class="cont-link-section" data-lesson-id="242278" data-section-id="242278">Section Link</a>
                                    <a class="cont-link-tab" data-tab="questions">Tab Link</a>
                                `)}
                        </SyntaxHighlighter>
                    </div>
                    <APItable data={[
                        {
                            option: 'data-lesson-id',
                            attr: API_ATTR.DATA,
                            required: true,
                            description: 'ID of link lesson'
                        },
                        {
                            option: 'cont-link-section',
                            attr: API_ATTR.DATA,
                            required: false,
                            description: 'ID of link section'
                        },
                        {
                            option: 'data-tab',
                            attr: API_ATTR.DATA,
                            required: false,
                            description: 'Tab hash name (quiz, questions, quizQuestions, exerciseQuestions, resources)'
                        },
                    ]}/>
                    <span className='cont-head-c js-pageMarker-viz'>Media Links</span>
                    <div className='cont-block cont-block-outlined'>
                        <div className='cont-block-body cont-text-center'>
                            <>
                                <button className="cont-media cont-link-video"
                                        data-media-name="Worked example 2"></button>
                                <button className="cont-media cont-link-audio" data-media-id="242278"></button>
                                <button className="cont-media cont-link-document"
                                        data-media-name="Worksheet 2.1.1"></button>
                                <button className="cont-media cont-link-widget" data-media-id="242278"></button>
                                <button className="cont-media cont-link-scorcher" data-media-id="242278"></button>
                                <button className="cont-media cont-link-desmos-graph" data-media-id="242278"></button>
                                <button className="cont-media cont-link-desmos-geometry"
                                        data-media-id="242278"></button>

                                <p>Download document <a className="cont-link-document" data-media-id="242278">here</a></p>
                            </>
                        </div>
                        <SyntaxHighlighter language="html" style={{}} className={"cont-block-code"}>
                            {beautifyHTML(`
                                    <button class="cont-media cont-link-video" data-media-name="Worked example 2"></button>
                                    <button class="cont-media cont-link-audio" data-media-id="242278"></button>
                                    <button class="cont-media cont-link-document" data-media-name="Worksheet 2.1.1"></button>
                                    <button class="cont-media cont-link-widget" data-media-id="242278"></button>
                                    <button class="cont-media cont-link-scorcher" data-media-id="242278"></button>
                                    <button class="cont-media cont-link-desmos-graph" data-media-id="242278"></button>
                                    <button class="cont-media cont-link-desmos-geometry" data-media-id="242278"></button>
                                    Download document <a class="cont-link-document" data-media-id="242278">here</a>
                                `)}
                        </SyntaxHighlighter>
                    </div>
                    <APItable data={[
                        {
                            option: 'cont-media',
                            attr: API_ATTR.CLASS,
                            required: true,
                            description: 'Core media link class'
                        },
                        {
                            option: 'data-media-id',
                            attr: API_ATTR.DATA,
                            required: false,
                            description: 'Media id as stored in the media database'
                        },
                        {
                            option: 'data-media-name',
                            attr: API_ATTR.DATA,
                            required: false,
                            description: 'Media name, required if media id is not used'
                        },
                        {
                            option: 'data-media-file',
                            attr: API_ATTR.DATA,
                            required: false,
                            description: 'Path to media media file'
                        },
                    ]}/>
                    <span className='cont-head-c js-pageMarker-viz'>Other Links</span>
                    <div className='cont-block cont-block-outlined'>
                        <div className='cont-block-body'>
                            <>
                                <p><a className="cont-link-walkthrough" data-question-id="242278">Walkthrough 1</a></p>
                                <p><a className="cont-link-question" data-tab="exerciseQuestions" data-question-id="242278">Question 1</a></p>
                                <p><a className="cont-link-question" data-tab="exerciseQuestions" data-question-number="3">Question 3</a></p>
                                <p><a className="cont-link-question-set" data-question-set-id="242278">Question set
                                    1</a></p>
                                <p><a className="cont-link-glossary" data-glossary-id="242278">vegetation</a></p>
                                <p><a className="cont-link-example" data-example-number="1">Example Link</a></p>
                            </>
                        </div>
                        <SyntaxHighlighter language="html" style={{}} className={"cont-block-code"}>
                            {beautifyHTML(`
                                    <a class="cont-link-walkthrough" data-question-id="242278">Walkthrough 1</a>
                                    <a class="cont-link-question" data-tab="exerciseQuestions" data-question-id="242278">Question 1</a>
                                    <a class="cont-link-question" data-tab="exerciseQuestions" data-question-number="3">Question 3</a>
                                    <a class="cont-link-question-set" data-question-set-id="242278">Question set 1</a>
                                    <a class="cont-link-glossary" data-glossary-id="242278">vegetation</a>
                                    <a class="cont-link-example" data-example-number="1">Example Link</a>
                                `)}
                        </SyntaxHighlighter>
                    </div>
                    <APItable data={[
                        {
                            option: 'data-question-id',
                            attr: API_ATTR.DATA,
                            required: true,
                            description: 'Question ID'
                        },
                        {
                            option: 'data-question-set-id',
                            attr: API_ATTR.DATA,
                            required: true,
                            description: 'Question Set ID'
                        },
                        {
                            option: 'data-glossary-id',
                            attr: API_ATTR.DATA,
                            required: true,
                            description: 'Glossary ID'
                        },
                        {
                            option: 'data-example-number',
                            attr: API_ATTR.DATA,
                            required: true,
                            description: 'Example number'
                        },
                    ]}/>
                    <span className='cont-head-c js-pageMarker-viz'>Shortcut anchor</span>
                    <p>A shortcut link will be added into the right side panel that will scroll to this anchor
                        element.</p>
                    <div className='js-group-pageMarker'>
                        <span id='bHeadAanchor' className='cont-head-d js-pageMarker-viz'>B-head shortcut anchor</span>
                        <div className="cont-block cont-block-outlined">
                            <div className="cont-block-body">
                                <p>
                                    <span
                                        className="cont-head-b cont-shortcut-anchor-temp">Lorem ipsum dolor sit amet</span>
                                </p>
                            </div>
                            <SyntaxHighlighter language="html" style={{}} className={"cont-block-code"}>
                                {beautifyHTML(`
                                    <span class="cont-head-b cont-shortcut-anchor">Lorem ipsum dolor sit amet</span>
                                `)}
                            </SyntaxHighlighter>
                        </div>
                        <APItable data={[
                            {
                                option: 'cont-shortcut-anchor',
                                attr: API_ATTR.CLASS,
                                required: true,
                                description: 'Core shortcut anchor class'
                            },
                        ]}/>
                        <span className='cont-head-d js-pageMarker-viz'>Generic shortcut anchor</span>
                        <div className="cont-block cont-block-outlined">
                            <div className="cont-block-body">
                                <p>
                                    <span className="cont-shortcut-anchor-temp"
                                          data-marker-title='Shortcut anchor link'/>
                                    <span>Duis convallis convallis tellus id. Est ullamcorper eget nulla facilisi etiam dignissim diam. Rhoncus est pellentesque elit ullamcorper dignissim cras tincidunt.</span>
                                </p>
                            </div>
                            <SyntaxHighlighter language="html" style={{}} className={"cont-block-code"}>
                                {beautifyHTML(`
                                    <span class="cont-shortcut-anchor" data-marker-title='Lorem ipsum dolor sit ame'/>
                                    <span>Duis convallis convallis tellus id. Est ullamcorper eget nulla facilisi etiam dignissim diam. Rhoncus est pellentesque elit ullamcorper dignissim cras tincidunt.</span>
                                `)}
                            </SyntaxHighlighter>
                        </div>
                        <APItable data={[
                            {
                                option: 'cont-shortcut-anchor',
                                attr: API_ATTR.CLASS,
                                required: true,
                                description: 'Core shortcut anchor class'
                            },
                            {
                                option: 'data-marker-title',
                                attr: API_ATTR.DATA,
                                required: true,
                                description: 'Name of the link in the menu'
                            },
                            {
                                option: 'data-marker-id',
                                attr: API_ATTR.DATA,
                                required: false,
                                description: 'A reference id used if you want to nest links'
                            },
                            {
                                option: 'data-marker-parent',
                                attr: API_ATTR.DATA,
                                required: false,
                                description: 'A reference to the parent id to nest it under that link'
                            },
                        ]}/>
                    </div>
                </div>
                <span className='cont-head-b js-pageMarker-viz'>Roll-over tooltips</span>
                <div className='js-group-pageMarker'>
                    <span className='cont-head-c js-pageMarker-viz'>General tooltip</span>
                    <div className="cont-block cont-block-outlined">
                        <div className="cont-block-body">
                            A modern artist’s <span className="cont-tooltip"
                                                    data-tooltip="the way that someone or something is shown or described"
                                                    data-type="tooltip"><b>representation</b></span> of life on the Nile
                            in ancient Egypt.
                        </div>
                        <SyntaxHighlighter language="html" style={{}} className={"cont-block-code"}>
                            {beautifyHTML(`
                                <span class="cont-tooltip" data-type="tooltip" data-tooltip="the way that someone or something is shown or described"> ... </span>
                            `)}
                        </SyntaxHighlighter>
                    </div>
                    <APItable data={[
                        {
                            option: 'cont-tooltip',
                            attr: API_ATTR.CLASS,
                            required: true,
                            description: 'Core tooltip class'
                        },
                        {
                            option: 'data-tooltip',
                            attr: API_ATTR.DATA,
                            required: true,
                            description: 'Tooltip rollover text'
                        },
                        {
                            option: 'data-type',
                            attr: API_ATTR.DATA,
                            required: true,
                            description: 'The toggle-data attribute value should be "tooltip"'
                        },
                    ]}/>
                    <span className='cont-head-c js-pageMarker-viz'>Glossary tooltip</span>
                    <div className="cont-block cont-block-outlined">
                        <div className="cont-block-body">
                            What impact did floodwater seem to have on nearby <span data-glossary-term="vegetation"
                                                                                    data-glossary-definition="the plants found in an area such as trees, shrubs and grasses"
                                                                                    className="cont-glossary-tooltip">vegetation</span>?
                        </div>
                        <SyntaxHighlighter language="html" style={{}} className={"cont-block-code"}>
                            {beautifyHTML(`
                                <span data-glossary-id="12888585" data-glossary-term="vegetation" data-glossary-definition="the plants found in an area such as trees, shrubs and grasses" class="cont-glossary-tooltip">vegetation</span>
                            `)}
                        </SyntaxHighlighter>
                    </div>
                    <APItable data={[
                        {
                            option: 'cont-glossary-tooltip',
                            attr: API_ATTR.CLASS,
                            required: true,
                            description: 'Core glossary tooltip class'
                        },
                        {
                            option: 'data-glossary-id',
                            attr: API_ATTR.DATA,
                            required: false,
                            description: 'Glossary ID. Either data-glossary-id, or  data-glossary-term and data-glossary-definition are required'
                        },
                        {
                            option: 'data-glossary-term',
                            attr: API_ATTR.DATA,
                            required: true,
                            description: 'Glossary term'
                        },
                        {
                            option: 'data-glossary-definition',
                            attr: API_ATTR.DATA,
                            required: true,
                            description: 'Glossary definition'
                        },
                    ]}/>
                </div>
                <span className='cont-head-b js-pageMarker-viz'>Blockquotes</span>
                <div className='js-group-pageMarker'>
                    <span className='cont-head-c js-pageMarker-viz'>Basic blockquote</span>
                    <div className='cont-block cont-block-outlined'>
                        <div className='cont-block-body'>
                            <figure className='cont-blockquote'>
                                <blockquote>
                                    <p>Today is the tomorrow you worried about yesterday.</p>
                                </blockquote>
                            </figure>
                        </div>
                        <SyntaxHighlighter language="html" style={{}} className={"cont-block-code"}>
                            {beautifyHTML(`
                                <figure class='cont-blockquote'>
                                    <blockquote>
                                        <p>Today is the tomorrow you worried about yesterday.</p>
                                    </blockquote>
                                </figure>
                            `)}
                        </SyntaxHighlighter>
                    </div>
                    <APItable data={[
                        {
                            option: 'cont-blockquote',
                            attr: API_ATTR.CLASS,
                            required: true,
                            description: 'Core block quote class'
                        },
                        {
                            option: 'figure',
                            attr: API_ATTR.ELEMENT,
                            required: true,
                            description: 'All block quotes should be wrapped in a figure element'
                        },
                    ]}/>
                    <span className='cont-head-c js-pageMarker-viz'>Filled blockquote</span>
                    <div className='cont-block cont-block-outlined'>
                        <div className='cont-block-body'>
                            <figure className='cont-blockquote cont-blockquote-filled'>
                                <blockquote>
                                    <p>Today is the tomorrow you worried about yesterday.</p>
                                </blockquote>
                            </figure>
                        </div>
                        <SyntaxHighlighter language="html" style={{}} className={"cont-block-code"}>
                            {beautifyHTML(`
                                <figure class='cont-blockquote cont-blockquote-filled'>
                                    <blockquote>
                                        <p>Today is the tomorrow you worried about yesterday.</p>
                                    </blockquote>
                                </figure>
                            `)}
                        </SyntaxHighlighter>
                    </div>
                    <APItable data={[
                        {
                            option: 'cont-blockquote-filled',
                            attr: API_ATTR.CLASS,
                            required: false,
                            description: 'Filled block quote'
                        },
                    ]}/>
                    <span className='cont-head-c js-pageMarker-viz'>Blockquote with caption</span>
                    <div className='cont-block cont-block-outlined'>
                        <div className='cont-block-body'>
                            <figure className='cont-blockquote cont-blockquote-filled'>
                                <blockquote>
                                    <strong>Article 23:</strong>
                                    <p>(1) Everyone has the right to work, to free choice of employment, to just and
                                        favourable conditions of work and to protection against unemployment.</p>
                                    <p>(2) Everyone, without any discrimination, has the right to equal pay for equal
                                        work.</p>
                                </blockquote>
                                <figcaption className='cont-caption'>
                                    Universal Declaration of Human Rights
                                </figcaption>
                            </figure>
                        </div>
                        <SyntaxHighlighter language="html" style={{}} className={"cont-block-code"}>
                            {beautifyHTML(`
                                <figure class='cont-blockquote cont-blockquote-filled'>
                                    <blockquote>
                                        <strong>Article 23:</strong>
                                        <p>(1) Everyone has the right to work, to free choice of employment, to just and favourable conditions of work and to protection against unemployment.</p>
                                        <p>(2) Everyone, without any discrimination, has the right to equal pay for equal work.</p>
                                    </blockquote>
                                    <figcaption class='cont-caption'>
                                        Universal Declaration of Human Rights
                                    </figcaption>
                                </figure>
                            `)}
                        </SyntaxHighlighter>
                    </div>
                    <APItable data={[
                        {
                            option: 'cont-caption',
                            attr: API_ATTR.CLASS,
                            required: true,
                            description: 'Core figure caption class. Required on figcaption elements when used.'
                        },
                        {
                            option: 'cont-caption-title',
                            attr: API_ATTR.CLASS,
                            required: false,
                            description: 'Figure caption title class'
                        },
                    ]}/>
                </div>
                <span className='cont-head-b js-pageMarker-viz'>Lists</span>
                <div className='cont-block cont-block-outlined'>
                    <div className='cont-block-body'>
                        <p>Disc</p>
                        <ul className='cont-list-disc'>
                            <li>Red</li>
                            <li>Green</li>
                            <li>Blue</li>
                        </ul>
                        <p>Circle</p>
                        <ul className='cont-list-circle'>
                            <li>Red</li>
                            <li>Green</li>
                            <li>Blue</li>
                        </ul>
                        <p>Square</p>
                        <ul className='cont-list-square'>
                            <li>Red</li>
                            <li>Green</li>
                            <li>Blue</li>
                        </ul>
                        <p>Decimal</p>
                        <ol className='cont-list-decimal'>
                            <li>Red</li>
                            <li>Green</li>
                            <li>Blue</li>
                        </ol>
                        <p>Lower alpha</p>
                        <ol className='cont-list-lower-alpha'>
                            <li>Red</li>
                            <li>Green</li>
                            <li>Blue</li>
                        </ol>
                        <p>Upper alpha</p>
                        <ol className='cont-list-upper-alpha'>
                            <li>Red</li>
                            <li>Green</li>
                            <li>Blue</li>
                        </ol>
                        <p>Lower roman</p>
                        <ol className='cont-list-lower-roman'>
                            <li>Red</li>
                            <li>Green</li>
                            <li>Blue</li>
                        </ol>
                        <p>Upper roman</p>
                        <ol className='cont-list-upper-roman'>
                            <li>Red</li>
                            <li>Green</li>
                            <li>Blue</li>
                        </ol>
                    </div>
                    <SyntaxHighlighter language="html" style={{}} className={"cont-block-code"}>
                        {beautifyHTML(`
                            <p>Disc</p>
                            <ul class='cont-list-disc'>...</ul>
                            <p>Circle</p>
                            <ul class='cont-list-circle'>...</ul>
                            <p>Square</p>
                            <ul class='cont-list-square'>...</ul>
                            <p>Decimal</p>
                            <ol class='cont-list-decimal'>...</ol>
                            <p>Lower alpha</p>
                            <ol class='cont-list-lower-alpha'>...</ol>
                            <p>Upper alpha</p>
                            <ol class='cont-list-upper-alpha'>...</ol>
                            <p>Lower roman</p>
                            <ol class='cont-list-lower-roman'>...</ol>
                            <p>Upper roman</p>
                            <ol class='cont-list-upper-roman'>...</ol>
                        `)}
                    </SyntaxHighlighter>
                </div>
                <span className='cont-head-b js-pageMarker-viz'>Tables</span>
                <div className='js-group-pageMarker'>
                    <span className='cont-head-c js-pageMarker-viz'>Basic table</span>
                    <div className='cont-block cont-block-outlined'>
                        <div className='cont-block-body'>
                            <ExampleTable className={'cont-table-basic'}/>
                        </div>
                        <SyntaxHighlighter language="html" style={{}} className={"cont-block-code"}>
                            {beautifyHTML(`
                                <table class='cont-table cont-table-basic'>
                                    ...
                                </table>
                            `)}
                        </SyntaxHighlighter>
                    </div>
                    <APItable data={[
                        {option: 'cont-table', attr: API_ATTR.CLASS, required: true, description: 'Core table class'},
                        {
                            option: 'cont-table-basic',
                            attr: API_ATTR.CLASS,
                            required: false,
                            description: 'Basic table style'
                        },
                    ]}/>
                    <span className='cont-head-c js-pageMarker-viz'>Basic table with caption</span>
                    <div className='cont-block cont-block-outlined'>
                        <div className='cont-block-body'>
                            <figure>
                                <ExampleTable className={'cont-table-basic'}/>
                                <figcaption className="cont-caption">Lorem ipsum dolor sit amet, consectetur adipiscing
                                    elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                                </figcaption>
                            </figure>
                        </div>
                        <SyntaxHighlighter language="html" style={{}} className={"cont-block-code"}>
                            {beautifyHTML(`
                                <figure>
                                    <table class='cont-table cont-table-basic'>
                                        ...
                                    </table>
                                    <figcaption class="cont-caption">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</figcaption>
                                </figure>
                            `)}
                        </SyntaxHighlighter>
                    </div>
                    <APItable data={[
                        {
                            option: 'figure',
                            attr: API_ATTR.ELEMENT,
                            required: true,
                            description: 'Wrap table in figure element'
                        },
                        {
                            option: 'figcaption',
                            attr: API_ATTR.ELEMENT,
                            required: false,
                            description: 'Wrap table in figure element'
                        },
                        {
                            option: 'cont-caption',
                            attr: API_ATTR.CLASS,
                            required: false,
                            description: 'Figure caption title class'
                        },
                    ]}/>
                    <span className='cont-head-c js-pageMarker-viz'>Filled table</span>
                    <div className='cont-block cont-block-outlined'>
                        <div className='cont-block-body'>
                            <ExampleTable className={'cont-table-filled'}/>
                        </div>
                        <SyntaxHighlighter language="html" style={{}} className={"cont-block-code"}>
                            {beautifyHTML(`
                                <table class='cont-table cont-table-filled'>
                                    ...
                                </table>
                            `)}
                        </SyntaxHighlighter>
                    </div>
                    <APItable data={[
                        {option: 'cont-table', attr: API_ATTR.CLASS, required: true, description: 'Core table class'},
                        {
                            option: 'cont-table-filled',
                            attr: API_ATTR.CLASS,
                            required: false,
                            description: 'Filled table style'
                        },
                    ]}/>
                    <span className='cont-head-c js-pageMarker-viz'>Table with column widths</span>
                    <div className='cont-block cont-block-outlined'>
                        <div className='cont-block-body'>
                            <ExampleColumnTable className={'cont-table-basic'}/>
                        </div>
                        <SyntaxHighlighter language="html" style={{}} className={"cont-block-code"}>
                            {beautifyHTML(`
                                <table class='cont-table cont-table-basic'>
                                    <colgroup>
                                        <col class="cont-width-80"/>
                                        <col class="cont-width-20">
                                    </colgroup>
                                    ...
                                </table>
                            `)}
                        </SyntaxHighlighter>
                    </div>
                    <APItable data={[
                        {option: 'cont-table', attr: API_ATTR.CLASS, required: true, description: 'Core table class'},
                        {
                            option: 'cont-table-basic',
                            attr: API_ATTR.CLASS,
                            required: false,
                            description: 'Basic table style'
                        },
                        {
                            option: 'colgroup',
                            attr: API_ATTR.ELEMENT,
                            required: false,
                            description: 'Add colgroup to table'
                        },
                        {
                            option: 'col',
                            attr: API_ATTR.ELEMENT,
                            required: false,
                            description: 'Add columns to column group'
                        },
                        {
                            option: 'cont-width-*',
                            attr: API_ATTR.CLASS,
                            required: false,
                            description: 'Column width percent 10%, 15%, 20%, 25%, 30%, 35%, 40%, 45%, 50%, 55%, 60%, 65%, 70%, 75%, 80%, 85%, 90%, 95%, 100%'
                        },
                    ]}/>
                    <span className='cont-head-c js-pageMarker-viz'>Table with align cell content</span>
                    <div className='cont-block cont-block-outlined'>
                        <div className='cont-block-body'>
                            <ExampleColumnTable className={'cont-table-basic cont-table-align-center'}/>
                        </div>
                        <SyntaxHighlighter language="html" style={{}} className={"cont-block-code"}>
                            {beautifyHTML(`
                                <table class='cont-table cont-table-basic cont-table-align-center'>
                                    ...
                                </table>
                            `)}
                        </SyntaxHighlighter>
                    </div>
                    <APItable data={[
                        {
                            option: 'cont-table-align-left',
                            attr: API_ATTR.CLASS,
                            required: true,
                            description: 'Align table cell content left'
                        },
                        {
                            option: 'cont-table-align-center',
                            attr: API_ATTR.CLASS,
                            required: false,
                            description: 'Align table cell content center'
                        },
                        {
                            option: 'cont-table-align-right',
                            attr: API_ATTR.CLASS,
                            required: false,
                            description: 'Align table cell content right'
                        },
                        {
                            option: 'cont-table-align-justify',
                            attr: API_ATTR.CLASS,
                            required: false,
                            description: 'Align table cell content justify'
                        },
                    ]}/>
                </div>
                <span className='cont-head-b js-pageMarker-viz'>Images</span>
                <div className='js-group-pageMarker'>
                    <ol>
                        <li>Images should always be wrapped by a figure element.</li>
                        <li>Images should <b>not</b> exceed 10Mb in size.</li>
                    </ol>
                    <span className='cont-head-c js-pageMarker-viz'>Basic image</span>
                    <div className='cont-block cont-block-outlined'>
                        <div className='cont-block-body'>
                            <figure className="cont-img">
                                <img src="/users/generalFiles/images/sample.jpg"/>
                            </figure>
                        </div>
                        <SyntaxHighlighter language="html" style={{}} className={"cont-block-code"}>
                            {beautifyHTML(`
                                <figure class="cont-img">
                                    <img src="/users/generalFiles/images/sample.jpg"/>
                                </figure>
                            `)}
                        </SyntaxHighlighter>
                    </div>
                    <APItable data={[
                        {
                            option: 'cont-img',
                            attr: API_ATTR.CLASS,
                            required: true,
                            description: 'Core image class 75% default width (one of cont-img or cont-img-embedded is required)'
                        },
                        {
                            option: 'figure',
                            attr: API_ATTR.ELEMENT,
                            required: true,
                            description: 'All images should be wrapped in a figure element'
                        },
                    ]}/>
                    <span className='cont-head-c js-pageMarker-viz'>Icon image</span>
                    <p>This is a small image that displays 40px x 40px and is not stretched to a percentage of the page width like the basic image.</p>
                    <div className='cont-block cont-block-outlined'>
                        <div className='cont-block-body'>
                            <figure className="cont-img-icon">
                                <img src="/users/generalFiles/images/sample.jpg"/>
                            </figure>
                        </div>
                        <SyntaxHighlighter language="html" style={{}} className={"cont-block-code"}>
                            {beautifyHTML(`
                                <figure class="cont-img-icon">
                                    <img src="/users/generalFiles/images/sample.jpg"/>
                                </figure>
                            `)}
                        </SyntaxHighlighter>
                    </div>
                    <APItable data={[
                        {
                            option: 'cont-img-icon',
                            attr: API_ATTR.CLASS,
                            required: true,
                            description: 'displays a 40px x 40px image'
                        },
                        {
                            option: 'figure',
                            attr: API_ATTR.ELEMENT,
                            required: true,
                            description: 'All images should be wrapped in a figure element'
                        },
                    ]}/>
                    <span className='cont-head-c js-pageMarker-viz'>Image size</span>
                    <div className='cont-block cont-block-outlined'>
                        <div className='cont-block-body'>
                            <p><strong>100% width</strong></p>
                            <figure className="cont-img cont-img-s-100">
                                <img src="/users/generalFiles/images/sample.jpg"/>
                            </figure>
                            <p><strong>75% width (default)</strong></p>
                            <figure className="cont-img">
                                <img src="/users/generalFiles/images/sample.jpg"/>
                            </figure>
                            <p><strong>50% width</strong></p>
                            <figure className="cont-img cont-img-s-50">
                                <img src="/users/generalFiles/images/sample.jpg"/>
                            </figure>
                            <p><strong>40% width</strong></p>
                            <figure className="cont-img cont-img-s-40">
                                <img src="/users/generalFiles/images/sample.jpg"/>
                            </figure>
                            <p><strong>30% width</strong></p>
                            <figure className="cont-img cont-img-s-30">
                                <img src="/users/generalFiles/images/sample.jpg"/>
                            </figure>
                        </div>
                        <SyntaxHighlighter language="html" style={{}} className={"cont-block-code"}>
                            {beautifyHTML(`
                                <div class="cont-block cont-block-outlined">
                                    <div class="cont-block-body">
                                        <p>100% width</p>
                                        <figure class="cont-img cont-img-s-100">
                                            <img src="welcome.gif"/>
                                        </figure>
                                        <p>75% width (default)</p>
                                        <figure class="cont-img">
                                            <img src="welcome.gif"/>
                                        </figure>
                                        <p>50% width</p>
                                        <figure class="cont-img cont-img-s-50">
                                            <img src="welcome.gif"/>
                                        </figure>
                                        <p>40% width</p>
                                        <figure class="cont-img cont-img-s-40">
                                            <img src="welcome.gif"/>
                                        </figure>
                                        <p>30% width</p>
                                        <figure class="cont-img cont-img-s-30">
                                            <img src="welcome.gif"/>
                                        </figure>
                                    </div>
                                </div>
                            `)}
                        </SyntaxHighlighter>
                    </div>
                    <APItable data={[
                        {
                            option: 'cont-img',
                            attr: API_ATTR.CLASS,
                            required: true,
                            description: 'Core image class, 75% default width (one of cont-img or cont-img-embedded is required)'
                        },
                        {
                            option: 'cont-img-embedded',
                            attr: API_ATTR.CLASS,
                            required: true,
                            description: 'Core embedded image class (one of cont-img or cont-img-embedded is required)'
                        },
                        {
                            option: 'cont-img-s-30',
                            attr: API_ATTR.CLASS,
                            required: false,
                            description: 'image 30% width'
                        },
                        {
                            option: 'cont-img-s-40',
                            attr: API_ATTR.CLASS,
                            required: false,
                            description: 'image 40% width'
                        },
                        {
                            option: 'cont-img-s-45',
                            attr: API_ATTR.CLASS,
                            required: false,
                            description: 'image 45% width'
                        },
                        {
                            option: 'cont-img-s-50',
                            attr: API_ATTR.CLASS,
                            required: false,
                            description: 'image 50% width'
                        },
                        {
                            option: 'cont-img-s-60',
                            attr: API_ATTR.CLASS,
                            required: false,
                            description: 'image 60% width'
                        },
                        {
                            option: 'cont-img-s-70',
                            attr: API_ATTR.CLASS,
                            required: false,
                            description: 'image 70% width'
                        },
                        {
                            option: 'cont-img-s-75',
                            attr: API_ATTR.CLASS,
                            required: false,
                            description: 'image 75% width'
                        },
                        {
                            option: 'cont-img-s-80',
                            attr: API_ATTR.CLASS,
                            required: false,
                            description: 'image 70% width'
                        },
                        {
                            option: 'cont-img-s-90',
                            attr: API_ATTR.CLASS,
                            required: false,
                            description: 'image 70% width'
                        },
                        {
                            option: 'cont-img-s-100',
                            attr: API_ATTR.CLASS,
                            required: false,
                            description: 'image 100% width'
                        },
                    ]}/>
                    <span className='cont-head-c js-pageMarker-viz'>Image alignment</span>
                    <div className='cont-block cont-block-outlined'>
                        <div className='cont-block-body'>
                            <p><strong>Left aligned</strong></p>
                            <figure className="cont-img cont-img-left">
                                <img src="/users/generalFiles/images/sample.jpg"/>
                            </figure>
                            <p><strong>Center aligned</strong></p>
                            <figure className="cont-img cont-img-center">
                                <img src="/users/generalFiles/images/sample.jpg"/>
                            </figure>
                            <p><strong>Right aligned</strong></p>
                            <figure className="cont-img cont-img-right">
                                <img src="/users/generalFiles/images/sample.jpg"/>
                            </figure>
                        </div>
                        <SyntaxHighlighter language="html" style={{}} className={"cont-block-code"}>
                            {beautifyHTML(`
                                <div class="cont-block cont-block-outlined">
                                    <div class="cont-block-body">
                                        <p>Left aligned</p>
                                        <figure class="cont-img cont-img-left">
                                            <img src="welcome.gif"/>
                                        </figure>
                                        <p>Center aligned</p>
                                        <figure class="cont-img cont-img-center">
                                            <img src="welcome.gif"/>
                                        </figure>                                        
                                        <p>Right aligned</p>
                                        <figure class="cont-img cont-img-right">
                                            <img src="welcome.gif"/>
                                        </figure>
                                    </div>
                                </div>
                            `)}
                        </SyntaxHighlighter>
                    </div>
                    <APItable data={[
                        {
                            option: 'cont-img',
                            attr: API_ATTR.CLASS,
                            required: true,
                            description: 'Core image class, 75% default width (one of cont-img or cont-img-embedded is required)'
                        },
                        {
                            option: 'figure',
                            attr: API_ATTR.ELEMENT,
                            required: true,
                            description: 'Images should be wrapped in a figure element'
                        },
                        {
                            option: 'cont-img-left',
                            attr: API_ATTR.CLASS,
                            required: false,
                            description: 'Image aligned left'
                        },
                        {
                            option: 'cont-img-center',
                            attr: API_ATTR.CLASS,
                            required: false,
                            description: 'Image aligned center'
                        },
                        {
                            option: 'cont-img-right',
                            attr: API_ATTR.CLASS,
                            required: false,
                            description: 'Image aligned right'
                        },
                    ]}/>
                    <span className='cont-head-c js-pageMarker-viz'>Embedded image</span>
                    <p>Embedded image figures should be placed before any wrapping text elements.</p>
                    <div className='cont-block cont-block-outlined'>
                        <div className='cont-block-body'>
                            <p><strong>Default</strong></p>
                            <figure className="cont-img-embedded">
                                <img src="/users/generalFiles/images/sample.jpg"/>
                            </figure>
                            <p>Duis convallis convallis tellus id. Est ullamcorper eget nulla facilisi etiam dignissim
                                diam. Rhoncus est pellentesque elit ullamcorper dignissim cras tincidunt. A pellentesque
                                sit amet porttitor eget dolor morbi non. Arcu vitae elementum curabitur vitae nunc sed
                                velit dignissim. Odio ut sem nulla pharetra diam. Euismod quis viverra nibh cras
                                pulvinar mattis. Viverra orci sagittis eu volutpat odio. Purus gravida quis blandit
                                turpis cursus in hac habitasse platea. Malesuada bibendum arcu vitae elementum curabitur
                                vitae nunc.</p>
                            <p><strong>Align left</strong></p>
                            <figure className="cont-img-embedded cont-img-embedded-left">
                                <img src="/users/generalFiles/images/sample.jpg"/>
                            </figure>
                            <p>Duis convallis convallis tellus id. Est ullamcorper eget nulla facilisi etiam dignissim
                                diam. Rhoncus est pellentesque elit ullamcorper dignissim cras tincidunt. A pellentesque
                                sit amet porttitor eget dolor morbi non. Arcu vitae elementum curabitur vitae nunc sed
                                velit dignissim. Odio ut sem nulla pharetra diam. Euismod quis viverra nibh cras
                                pulvinar mattis. Viverra orci sagittis eu volutpat odio. Purus gravida quis blandit
                                turpis cursus in hac habitasse platea. Malesuada bibendum arcu vitae elementum curabitur
                                vitae nunc.</p>
                            <p><strong>Altered size</strong></p>
                            <figure className="cont-img-embedded cont-img-s-30">
                                <img src="/users/generalFiles/images/sample.jpg"/>
                            </figure>
                            <p>Duis convallis convallis tellus id. Est ullamcorper eget nulla facilisi etiam dignissim
                                diam. Rhoncus est pellentesque elit ullamcorper dignissim cras tincidunt. A pellentesque
                                sit amet porttitor eget dolor morbi non. Arcu vitae elementum curabitur vitae nunc sed
                                velit dignissim. Odio ut sem nulla pharetra diam. Euismod quis viverra nibh cras
                                pulvinar mattis. Viverra orci sagittis eu volutpat odio. Purus gravida quis blandit
                                turpis cursus in hac habitasse platea. Malesuada bibendum arcu vitae elementum curabitur
                                vitae nunc.</p>
                            <p><strong>Block with caption</strong></p>
                            <figure className="cont-img-embedded cont-img-block">
                                <img src="/users/generalFiles/images/sample.jpg"/>
                                <figcaption className="cont-caption"><span className="cont-caption-title">1.1 Lorem ipsum</span> Lorem
                                    ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt
                                    ut labore et dolore magna aliqua.
                                </figcaption>
                            </figure>
                            <p>Duis convallis convallis tellus id. Est ullamcorper eget nulla facilisi etiam dignissim
                                diam. Rhoncus est pellentesque elit ullamcorper dignissim cras tincidunt. A pellentesque
                                sit amet porttitor eget dolor morbi non. Arcu vitae elementum curabitur vitae nunc sed
                                velit dignissim. Odio ut sem nulla pharetra diam. Euismod quis viverra nibh cras
                                pulvinar mattis. Viverra orci sagittis eu volutpat odio. Purus gravida quis blandit
                                turpis cursus in hac habitasse platea. Malesuada bibendum arcu vitae elementum curabitur
                                vitae nunc.</p>
                        </div>
                        <SyntaxHighlighter language="html" style={{}} className={"cont-block-code"}>
                            {beautifyHTML(`
                                <div class="cont-block cont-block-outlined">
                                    <div class="cont-block-body">
                                        <p>Default ...</p>
                                        <figure class="cont-img-embedded">
                                            <img src="welcome.gif"/>
                                        </figure>
                                        <p>Align left ...</p>
                                        <figure class="cont-img-embedded cont-img-embedded-left">
                                            <img src="welcome.gif"/>
                                        </figure>
                                        <p>Altered size ...</p>
                                        <figure class="cont-img-embedded cont-img-s-30">
                                            <img src="welcome.gif"/>
                                        </figure>
                                        <p>Block with caption ...</p>
                                        <figure class="cont-img-embedded cont-img-block">
                                            <img src="welcome.gif"/>
                                            <figcaption class="cont-caption"><span class="cont-caption-title">1.1 Lorem ipsum</span> Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</figcaption>
                                        </figure>
                                    </div>
                                </div>
                            `)}
                        </SyntaxHighlighter>
                    </div>
                    <APItable data={[
                        {
                            option: 'cont-img-embedded',
                            attr: API_ATTR.CLASS,
                            required: true,
                            description: 'Core embedded image class, default aligned right'
                        },
                        {
                            option: 'figure',
                            attr: API_ATTR.ELEMENT,
                            required: true,
                            description: 'Images should be wrapped in a figure element'
                        },
                        {
                            option: 'cont-img-embedded-left',
                            attr: API_ATTR.CLASS,
                            required: false,
                            description: 'Image aligned left'
                        },
                        {
                            option: 'cont-img-block',
                            attr: API_ATTR.CLASS,
                            required: false,
                            description: 'Add border box to figure'
                        },
                        {
                            option: 'figcaption ',
                            attr: API_ATTR.ELEMENT,
                            required: false,
                            description: 'Figure captions should be wrapped in a figcaption element'
                        },
                        {
                            option: 'cont-caption',
                            attr: API_ATTR.CLASS,
                            required: true,
                            description: 'Core figure caption class. Required on figcaption elements when used.'
                        },
                        {
                            option: 'cont-caption-title',
                            attr: API_ATTR.CLASS,
                            required: false,
                            description: 'Figure caption title class'
                        },
                    ]}/>
                    <span className='cont-head-c js-pageMarker-viz'>Images in a grid</span>
                    <p>Wrap images in &lt;figure&gt; elements.
                        Use <strong>cont-grid-col-sm-6</strong> on &lt;figure&gt; elements</p>
                    <div className='cont-block cont-block-outlined'>
                        <div className='cont-block-body'>
                            <div className="cont-grid-row">
                                <figure className="cont-img cont-grid-col-sm-6">
                                    <img src="/users/generalFiles/images/sample.jpg"/>
                                    <figcaption className="cont-caption"><span className="cont-caption-title">1.0 Lorem ipsum</span> Lorem
                                        ipsum dolor sit amet.
                                    </figcaption>
                                </figure>
                                <figure className="cont-img cont-grid-col-sm-6">
                                    <img src="/users/generalFiles/images/sample.jpg"/>
                                    <figcaption className="cont-caption"><span className="cont-caption-title">1.1 Lorem ipsum</span> Lorem
                                        ipsum dolor sit amet.
                                    </figcaption>
                                </figure>
                                <figure className="cont-img cont-grid-col-sm-6">
                                    <img src="/users/generalFiles/images/sample.jpg"/>
                                    <figcaption className="cont-caption"><span className="cont-caption-title">1.2 Lorem ipsum</span> Lorem
                                        ipsum dolor sit amet.
                                    </figcaption>
                                </figure>
                                <figure className="cont-img cont-grid-col-sm-6">
                                    <img src="/users/generalFiles/images/sample.jpg"/>
                                    <figcaption className="cont-caption"><span className="cont-caption-title">1.3 Lorem ipsum</span> Lorem
                                        ipsum dolor sit amet.
                                    </figcaption>
                                </figure>
                            </div>
                        </div>
                        <SyntaxHighlighter language="html" style={{}} className={"cont-block-code"}>
                            {beautifyHTML(`
                                <div class="cont-grid-row">
                                    <figure class="cont-img cont-grid-col-sm-6">
                                        <img src="/users/generalFiles/images/sample.jpg"/>
                                        <figcaption class="cont-caption">...</figcaption>
                                    </figure>
                                    <figure class="cont-img cont-grid-col-sm-6">
                                        <img src="/users/generalFiles/images/sample.jpg"/>
                                        <figcaption class="cont-caption">...</figcaption>
                                    </figure>
                                    <figure class="cont-img cont-grid-col-sm-6">
                                        <img src="/users/generalFiles/images/sample.jpg"/>
                                        <figcaption class="cont-caption">...</figcaption>
                                    </figure>
                                    <figure class="cont-img cont-grid-col-sm-6">
                                        <img src="/users/generalFiles/images/sample.jpg"/>
                                        <figcaption class="cont-caption">...</figcaption>
                                    </figure>
                                </div>
                            `)}
                        </SyntaxHighlighter>
                    </div>
                    <span className='cont-head-c js-pageMarker-viz'>Images and text in a grid</span>
                    <p>Wrap text blocks and images in &lt;figure&gt; elements.
                        Use <strong>cont-grid-col-sm-6</strong> on &lt;div&gt; elements</p>
                    <div className='cont-block cont-block-outlined'>
                        <div className='cont-block-body'>
                            <div className="cont-grid-row">
                                <div className="cont-grid-col-sm-6">
                                    <figure className="cont-img">
                                        <img src="/users/generalFiles/images/sample.jpg"/>
                                        <figcaption className="cont-caption"><span className="cont-caption-title">1.0 Lorem ipsum</span> Lorem
                                            ipsum dolor sit amet.
                                        </figcaption>
                                    </figure>
                                </div>
                                <div className="cont-grid-col-sm-6">
                                    <figure className="cont-img">
                                        <div className="cont-block cont-block-simple-1">
                                            <div className="cont-block-body">Lorem ipsum dolor sit amet, consectetur
                                                adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore
                                                magna aliqua. Urna duis convallis convallis tellus id interdum velit
                                                laoreet. A pellentesque sit amet porttitor. Phasellus egestas tellus
                                                rutrum tellus pellentesque eu. Ornare lectus sit amet est placerat in
                                                egestas. Non consectetur a erat nam at.
                                            </div>
                                        </div>
                                        <figcaption className="cont-caption">
                                            <figcaption className="cont-caption"><span className="cont-caption-title">1.1 Lorem ipsum</span> Lorem
                                                ipsum dolor sit amet.
                                            </figcaption>
                                        </figcaption>
                                    </figure>
                                </div>
                                <div className="cont-grid-col-sm-6">
                                    <figure className="cont-img">
                                        <div className="cont-block cont-block-simple-1">
                                            <div className="cont-block-body">Lorem ipsum dolor sit amet, consectetur
                                                adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore
                                                magna aliqua. Urna duis convallis convallis tellus id interdum velit
                                                laoreet. A pellentesque sit amet porttitor. Phasellus egestas tellus
                                                rutrum tellus pellentesque eu. Ornare lectus sit amet est placerat in
                                                egestas. Non consectetur a erat nam at.
                                            </div>
                                        </div>
                                        <figcaption className="cont-caption">
                                            <figcaption className="cont-caption"><span className="cont-caption-title">1.2 Lorem ipsum</span> Lorem
                                                ipsum dolor sit amet.
                                            </figcaption>
                                        </figcaption>
                                    </figure>
                                </div>
                                <div className="cont-grid-col-sm-6">
                                    <figure className="cont-img">
                                        <img src="/users/generalFiles/images/sample.jpg"/>
                                        <figcaption className="cont-caption"><span className="cont-caption-title">1.3 Lorem ipsum</span> Lorem
                                            ipsum dolor sit amet.
                                        </figcaption>
                                    </figure>
                                </div>
                            </div>
                        </div>
                        <SyntaxHighlighter language="html" style={{}} className={"cont-block-code"}>
                            {beautifyHTML(`
                                <div class="cont-grid-row">
                                    <div class="cont-grid-col-sm-6">
                                    <figure class="cont-img">
                                        <img src="/users/generalFiles/images/sample.jpg"/>
                                        <figcaption class="cont-caption">...</figcaption>
                                    </figure>
                                    </div>
                                    <div class="cont-grid-col-sm-6">
                                        <figure class="cont-img">
                                            <div class="cont-block cont-block-simple-1">
                                                <div class="cont-block-body">...</div>
                                            </div>
                                            <figcaption class="cont-caption">...</figcaption>
                                        </figure>
                                    </div>
                                    <div class="cont-grid-col-sm-6">
                                        <figure class="cont-img">
                                            <div class="cont-block cont-block-simple-1">
                                                <div class="cont-block-body">...</div>
                                            </div>
                                            <figcaption class="cont-caption">...</figcaption>
                                        </figure>
                                    </div>
                                    <div class="cont-grid-col-sm-6">
                                        <figure class="cont-img">
                                            <img src="/users/generalFiles/images/sample.jpg"/>
                                            <figcaption class="cont-caption">...</figcaption>
                                        </figure>
                                    </div>
                                </div>
                            `)}
                        </SyntaxHighlighter>
                    </div>
                </div>
                <span className='cont-head-b js-pageMarker-viz'>Blocks</span>
                <div className='js-group-pageMarker'>
                    <p>The Block Modules allows you to create and customize modular block components. These modules
                        follow a specific structure and use CSS modifier classes to modify their appearance and
                        behavior.</p>
                    <span className='cont-head-d'>Structure</span>
                    <p>The basic block module consists of three main elements:</p>
                    <ol className='cont-list-decimal'>
                        <li><code>{"<div class='cont-block'>"}</code> This is the container element that holds the
                            entire block module. It serves as the main wrapper for the module and provides the base
                            styling.
                        </li>
                        <li><code>{"<div class='cont-block-head'>"}</code> (Optional) This element represents the header
                            section of the block module.
                        </li>
                        <li><code>{"<div class='cont-block-body'>"}</code> This element represents the body section and
                            contains the main content of the module.
                        </li>
                    </ol>
                    <p>A basic block module.</p>
                    <div className='cont-block cont-block-outlined'>
                        <SyntaxHighlighter language="html" style={{}} className={"cont-block-code"}>
                            {beautifyHTML(`
                                <div class='cont-block'>
                                    <div class='cont-head-block'>
                                        <!-- Module Content Goes Here -->
                                    </div>
                                </div>
                            `)}
                        </SyntaxHighlighter>
                    </div>
                    <APItable data={[
                        {option: 'cont-block', attr: API_ATTR.CLASS, required: true, description: 'Core block class'},
                        {
                            option: 'cont-block-head',
                            attr: API_ATTR.CLASS,
                            required: false,
                            description: 'Core block header class'
                        },
                        {
                            option: 'cont-block-body',
                            attr: API_ATTR.CLASS,
                            required: true,
                            description: 'Core block body class'
                        },
                    ]}/>
                    <span className='cont-head-c js-pageMarker-viz'>Block options</span>
                    <div className='js-group-pageMarker'>
                        <span id='blockAccordion' className='cont-head-d js-pageMarker-viz'>Block with accordion functionality</span>
                        <div className='cont-block cont-block-outlined'>
                            <div className='cont-block-body'>
                                <div className='cont-block cont-block-outlined cont-block-accordion'>
                                    <div className='cont-block-head'>
                                        Block with accordion functionality
                                    </div>
                                    <ExampleBlockBodySmall/>
                                </div>
                            </div>
                            <SyntaxHighlighter language="html" style={{}} className={"cont-block-code"}>
                                {beautifyHTML(`
                                    <div class='cont-block cont-block-accordion'>
                                        <div class='cont-block-head'>
                                            Block with accordion functionality
                                        </div>
                                        <div class="cont-block-body">
                                            ...
                                        </div>
                                    </div>
                                `)}
                            </SyntaxHighlighter>
                        </div>
                        <APItable data={[
                            {
                                option: 'cont-block-accordion',
                                attr: API_ATTR.CLASS,
                                applyTo: API_APPLY_TO.BLOCK,
                                required: false,
                                description: 'Enables accordion interactive functionality'
                            },
                        ]}/>
                        <span className='cont-head-d js-pageMarker-viz'>Outlined block</span>
                        <div className='cont-block cont-block-outlined'>
                            <div className='cont-block-body'>
                                <div className='cont-block cont-block-outlined'>
                                    <div className='cont-block-head'>
                                        Outlined block
                                    </div>
                                    <ExampleBlockBodySmall/>
                                </div>
                            </div>
                            <SyntaxHighlighter language="html" style={{}} className={"cont-block-code"}>
                                {beautifyHTML(`
                                    <div class='cont-block cont-block-outlined'>
                                        <div class="cont-block-head">
                                            Outlined block
                                        </div>
                                        <div class="cont-block-body">
                                            ...
                                        </div>
                                    </div>
                                `)}
                            </SyntaxHighlighter>
                        </div>
                        <APItable data={[
                            {
                                option: 'cont-block-outlined',
                                attr: API_ATTR.CLASS,
                                applyTo: API_APPLY_TO.BLOCK,
                                required: false,
                                description: 'Adds a border to the block, based on the block colour'
                            },
                        ]}/>
                        <span className='cont-head-d js-pageMarker-viz'>Block with no rounded corners</span>
                        <div className='cont-block cont-block-outlined'>
                            <div className='cont-block-body'>
                                <div className='cont-block cont-block-outlined cont-block-sharp'>
                                    <div className='cont-block-head'>
                                        Block with no rounded corners
                                    </div>
                                    <ExampleBlockBodySmall/>
                                </div>
                            </div>
                            <SyntaxHighlighter language="html" style={{}} className={"cont-block-code"}>
                                {beautifyHTML(`
                                    <div class='cont-block cont-block-sharp'>
                                        <div class='cont-block-head'>
                                            Block with no rounded corners
                                        </div>
                                        <div class="cont-block-body">
                                            ...
                                        </div>
                                    </div>
                                `)}
                            </SyntaxHighlighter>
                        </div>
                        <APItable data={[
                            {
                                option: 'cont-block-sharp',
                                attr: API_ATTR.CLASS,
                                applyTo: API_APPLY_TO.BLOCK,
                                required: false,
                                description: 'Removes the corner radius from the block'
                            },
                        ]}/>
                        <span className='cont-head-d js-pageMarker-viz'>Block with left and right heading</span>
                        <div className='cont-block cont-block-outlined'>
                            <div className='cont-block-body'>
                                <div className='cont-block cont-block-outlined'>
                                    <div className='cont-block-head'>
                                        <div className='cont-block-head-title'>
                                            <div>
                                                Block text left
                                            </div>
                                            <div>
                                                Block text right
                                            </div>
                                        </div>
                                    </div>
                                    <ExampleBlockBodySmall/>
                                </div>
                            </div>
                            <SyntaxHighlighter language="html" style={{}} className={"cont-block-code"}>
                                {beautifyHTML(`
                                    <div class='cont-block'>
                                        <div class='cont-block-head'>
                                            <div class='cont-block-head-title'>
                                                <div>
                                                    Block text left
                                                </div>
                                                <div>
                                                    Block text right
                                                </div>
                                            </div>
                                        </div>
                                        <div class="cont-block-body">
                                            ...
                                        </div>
                                    </div>
                                `)}
                            </SyntaxHighlighter>
                        </div>
                        <span className='cont-head-d js-pageMarker-viz'>Block with no background</span>
                        <div className='cont-block cont-block-outlined'>
                            <div className='cont-block-body'>
                                <div className='cont-block cont-block-basic cont-block-no-bg'>
                                    <div className='cont-block-head'>
                                        Block with no background colour
                                    </div>
                                    <ExampleBlockBodySmall/>
                                </div>
                            </div>
                            <SyntaxHighlighter language="html" style={{}} className={"cont-block-code"}>
                                {beautifyHTML(`
                                    <div class='cont-block cont-block-no-bg'>
                                        <div class='cont-block-head'>
                                            Block with no background colour
                                        </div>
                                        <div class="cont-block-body">
                                            ...
                                        </div>
                                    </div>
                                `)}
                            </SyntaxHighlighter>
                        </div>
                        <APItable data={[
                            {
                                option: 'cont-block-no-bg',
                                attr: API_ATTR.CLASS,
                                applyTo: API_APPLY_TO.BLOCK,
                                required: false,
                                description: 'Removes background colour from the block body'
                            },
                        ]}/>
                        <span className='cont-head-d js-pageMarker-viz'>Block with adjusted colour saturation</span>
                        <div className='cont-block cont-block-outlined'>
                            <div className='cont-block-body'>
                                <div className='cont-block cont-block-custom-1 cont-colour-saturate-80'>
                                    <div className='cont-block-head'>
                                        Block with adjusted colour saturation
                                    </div>
                                    <ExampleBlockBodySmall/>
                                </div>
                            </div>
                            <SyntaxHighlighter language="html" style={{}} className={"cont-block-code"}>
                                {beautifyHTML(`
                                    <div class='cont-block cont-block-custom-1 cont-colour-saturate-80'>
                                        <div class='cont-block-head'>
                                            Block with adjusted colour saturation
                                        </div>
                                        <div class="cont-block-body">
                                            ...
                                        </div>
                                    </div>
                                `)}
                            </SyntaxHighlighter>
                        </div>
                        <APItable data={[
                            {
                                option: 'cont-colour-saturate-*',
                                attr: API_ATTR.CLASS,
                                applyTo: API_APPLY_TO.BLOCK,
                                required: false,
                                description: 'Colour saturation filter - 20%, 40%, 60%, 80%, 120%, 140%, 160%, 180%'
                            },
                        ]}/>
                        <span className='cont-head-d js-pageMarker-viz'>Embedded block</span>
                        <div className='cont-block cont-block-outlined'>
                            <div className='cont-block-body'>
                                <div className='cont-block cont-block-outlined cont-block-embedded'>
                                    <div className='cont-block-head'>
                                        Embedded block
                                    </div>
                                    <ExampleBlockBodySmall/>
                                </div>
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                                    incididunt ut labore et dolore magna aliqua. Urna duis convallis convallis tellus id
                                    interdum velit laoreet.</p>
                            </div>
                            <SyntaxHighlighter language="html" style={{}} className={"cont-block-code"}>
                                {beautifyHTML(`
                                    <div class='cont-block cont-block-embedded'>
                                        <div class='cont-block-head'>
                                            Embedded block
                                        </div>
                                        <div class="cont-block-body">
                                            ...
                                        </div>
                                    </div>
                                `)}
                            </SyntaxHighlighter>
                        </div>
                        <APItable data={[
                            {
                                option: 'cont-block-embedded',
                                attr: API_ATTR.CLASS,
                                applyTo: API_APPLY_TO.BLOCK,
                                required: false,
                                description: 'Lets text flow around the block, right aligned.'
                            },
                            {
                                option: 'cont-block-embedded-left',
                                attr: API_ATTR.CLASS,
                                applyTo: API_APPLY_TO.BLOCK,
                                required: false,
                                description: 'Lets text flow around the block, left aligned.'
                            },
                        ]}/>
                        <span className='cont-head-d js-pageMarker-viz'>Block with media buttons</span>
                        <div className='cont-block cont-block-outlined'>
                            <div className='cont-block-body'>
                                <div className='cont-block cont-block-outlined'>
                                    <div className='cont-block-head'>
                                        <div className='cont-block-head-title'>
                                            <div>Block with media button</div>
                                            <div>Right text</div>
                                        </div>
                                        <div className='cont-block-head-options'>
                                            <button className='cont-link-video' data-media-id="1047689"></button>
                                        </div>
                                    </div>
                                    <ExampleBlockBodySmall/>
                                </div>
                                <div className='cont-block cont-block-outlined'>
                                    <div className='cont-block-head'>
                                        Block with multiple media buttons
                                        <div className='cont-block-head-options'>
                                            <button className='cont-link-video' data-media-id="1047689"></button>
                                            <button className='cont-link-audio' data-media-id="1047689"></button>
                                            <button className='cont-link-document'
                                                    data-media-name="Document 1"></button>
                                        </div>
                                    </div>
                                    <ExampleBlockBodySmall/>
                                </div>
                            </div>
                            <SyntaxHighlighter language="html" style={{}} className={"cont-block-code"}>
                                {beautifyHTML(`
                                    <div class="cont-block">
                                        <div class="cont-block-head">
                                            Block with media button
                                            <div class="cont-block-head-options">
                                                <button class="cont-link-video" data-media-id="1047689"></button>
                                            </div>
                                        </div>
                                        <div class="cont-block-body">
                                            ...
                                        </div>
                                    </div>
                                    <div class="cont-block">
                                        <div class="cont-block-head">
                                            Block with multiple media buttons
                                            <div class="cont-block-head-options">
                                                <button class="cont-link-video" data-media-id="1047689"></button>
                                                <button class="cont-link-audio" data-media-id="1047689"></button>
                                                <button class="cont-link-document" data-media-name="Document 1"></button>
                                            </div>
                                        </div>
                                        <div class="cont-block-body">
                                            ...
                                        </div>
                                    </div>
                                `)}
                            </SyntaxHighlighter>
                        </div>
                        <div className='cont-block cont-block-outlined'>
                            <div className='cont-block-head'>
                                Button types
                            </div>
                            <div className='cont-block-body'>
                                <div className='cont-block-head-options'>
                                    <button className="cont-link-video" data-media-name="Document 1"></button>
                                    <button className="cont-link-audio" data-media-name="Document 1"></button>
                                    <button className="cont-link-document" data-media-name="Document 1"></button>
                                </div>
                            </div>
                        </div>
                        <APItable data={[
                            {
                                option: 'cont-block-head-options',
                                attr: API_ATTR.CLASS,
                                applyTo: API_APPLY_TO.DIV,
                                required: true,
                                description: 'Wrapping element for the buttons'
                            },
                            {
                                option: 'cont-link-video',
                                attr: API_ATTR.CLASS,
                                applyTo: API_APPLY_TO.BUTTON,
                                required: false,
                                description: 'Adds a video icon'
                            },
                            {
                                option: 'cont-link-audio',
                                attr: API_ATTR.CLASS,
                                applyTo: API_APPLY_TO.BUTTON,
                                required: false,
                                description: 'Adds an audio icon'
                            },
                            {
                                option: 'cont-link-document',
                                attr: API_ATTR.CLASS,
                                applyTo: API_APPLY_TO.BUTTON,
                                required: false,
                                description: 'Adds a document icon'
                            },
                            {
                                option: 'data-media-id',
                                attr: API_ATTR.DATA,
                                applyTo: API_APPLY_TO.BUTTON,
                                required: false,
                                description: 'Media id'
                            },
                            {
                                option: 'data-media-name',
                                attr: API_ATTR.DATA,
                                applyTo: API_APPLY_TO.BUTTON,
                                required: false,
                                description: 'Media name, required if media id is not used'
                            },
                            {
                                option: 'data-media-file',
                                attr: API_ATTR.DATA,
                                applyTo: API_APPLY_TO.BUTTON,
                                required: false,
                                description: 'Path to media media file'
                            },
                        ]}/>
                        <span className='cont-head-d js-pageMarker-viz'>Block with icons</span>
                        <div className='cont-block cont-block-outlined'>
                            <div className='cont-block-body'>
                                <div className='cont-block cont-block-basic cont-block-icon cont-block-icon-eye'>
                                    <div className='cont-block-head'>
                                        Block with icon
                                    </div>
                                    <ExampleBlockBodySmall/>
                                </div>
                            </div>
                            <div className='cont-block-body'>
                                <div className='cont-block cont-block-basic cont-block-icon cont-block-icon-think'>
                                    <div className='cont-block-head'>
                                        Block with icon and buttons
                                        <div className="cont-block-head-options">
                                            <button className="cont-link-audio" data-media-id="1047689"></button>
                                        </div>
                                    </div>
                                    <ExampleBlockBodySmall/>
                                </div>
                            </div>
                            <div className='cont-block-body'>
                                <div
                                    className='cont-block cont-block-basic cont-block-icon cont-block-accordion cont-block-icon-pencil'>
                                    <div className='cont-block-head'>
                                        Block with icon and accordion
                                    </div>
                                    <ExampleBlockBodySmall/>
                                </div>
                            </div>
                            <SyntaxHighlighter language="html" style={{}} className={"cont-block-code"}>
                                {beautifyHTML(`
                                    <div class='cont-block cont-block-icon cont-block-icon-eye'>
                                        <div class='cont-block-head'>
                                            Block with icon
                                        </div>
                                        <div class="cont-block-body">
                                            ...
                                        </div>
                                    </div>
                                    <div class='cont-block cont-block-icon cont-block-icon-build '>
                                        <div class='cont-block-head'>
                                            Block with icon
                                        </div>
                                        <div class="cont-block-body">
                                            ...
                                        </div>
                                    </div>                                    
                                    <div class='cont-block cont-block-icon cont-block-icon-think'>
                                        <div class='cont-block-head'>
                                            Block with icon and buttons
                                            <div class="cont-block-head-options">
                                                <button class="cont-link-audio" data-media-id="1047689"></button>
                                            </div>
                                        </div>
                                        <div class="cont-block-body">
                                            ...
                                        </div>
                                    </div>
                                    <div class='cont-block cont-block-icon cont-block-accordion cont-block-icon-pencil'>
                                        <div class='cont-block-head'>
                                            Block with icon and accordion
                                        </div>
                                        <div class="cont-block-body">
                                            ...
                                        </div>
                                    </div>
                                `)}
                            </SyntaxHighlighter>
                        </div>
                        <div className='cont-block cont-block-outlined'>
                            <div className='cont-block-head'>
                                Icon types
                            </div>
                            <div className='cont-block-body' style={{display: 'flex', justifyContent: 'center'}}>
                                <div className='cont-block-icon-demo cont-block-icon-eye'>
                                    <div className='cont-block-head'></div>
                                </div>
                                <div className='cont-block-icon-demo cont-block-icon-build'>
                                    <div className='cont-block-head'></div>
                                </div>
                                <div className='cont-block-icon-demo cont-block-icon-think'>
                                    <div className='cont-block-head'></div>
                                </div>
                                <div className='cont-block-icon-demo cont-block-icon-pencil'>
                                    <div className='cont-block-head'></div>
                                </div>
                                <div className='cont-block-icon-demo cont-block-icon-write'>
                                    <div className='cont-block-head'></div>
                                </div>
                                <div className='cont-block-icon-demo cont-block-icon-talk'>
                                    <div className='cont-block-head'></div>
                                </div>
                                <div className='cont-block-icon-demo cont-block-icon-magnify'>
                                    <div className='cont-block-head'></div>
                                </div>
                                <div className='cont-block-icon-demo cont-block-icon-develop'>
                                    <div className='cont-block-head'></div>
                                </div>
                                <div className='cont-block-icon-demo cont-block-icon-bag'>
                                    <div className='cont-block-head'></div>
                                </div>
                            </div>
                        </div>
                        <APItable data={[
                            {
                                option: 'cont-block-icon',
                                attr: API_ATTR.CLASS,
                                applyTo: API_APPLY_TO.BLOCK,
                                required: true,
                                description: 'Core block icon class'
                            },
                            {
                                option: 'cont-block-icon-eye',
                                attr: API_ATTR.CLASS,
                                applyTo: API_APPLY_TO.BLOCK,
                                required: false,
                                description: 'Adds an eye icon to the block head'
                            },
                            {
                                option: 'cont-block-icon-build',
                                attr: API_ATTR.CLASS,
                                applyTo: API_APPLY_TO.BLOCK,
                                required: false,
                                description: 'Adds an build icon to the block head'
                            },
                            {
                                option: 'cont-block-icon-think',
                                attr: API_ATTR.CLASS,
                                applyTo: API_APPLY_TO.BLOCK,
                                required: false,
                                description: 'Adds a think icon to the block head'
                            },
                            {
                                option: 'cont-block-icon-pencil',
                                attr: API_ATTR.CLASS,
                                applyTo: API_APPLY_TO.BLOCK,
                                required: false,
                                description: 'Adds a pencil icon to the block head'
                            },
                            {
                                option: 'cont-block-icon-write',
                                attr: API_ATTR.CLASS,
                                applyTo: API_APPLY_TO.BLOCK,
                                required: false,
                                description: 'Adds a write icon to the block head'
                            },
                            {
                                option: 'cont-block-icon-talk',
                                attr: API_ATTR.CLASS,
                                applyTo: API_APPLY_TO.BLOCK,
                                required: false,
                                description: 'Adds a talk icon to the block head'
                            },
                            {
                                option: 'cont-block-icon-magnify',
                                attr: API_ATTR.CLASS,
                                applyTo: API_APPLY_TO.BLOCK,
                                required: false,
                                description: 'Adds a magnify icon to the block head'
                            },
                            {
                                option: 'cont-block-icon-develop',
                                attr: API_ATTR.CLASS,
                                applyTo: API_APPLY_TO.BLOCK,
                                required: false,
                                description: 'Adds a develop icon to the block head'
                            },
                            {
                                option: 'cont-block-icon-bag',
                                attr: API_ATTR.CLASS,
                                applyTo: API_APPLY_TO.BLOCK,
                                required: false,
                                description: 'Adds a bag icon to the block head'
                            },
                        ]}/>
                        <span id='exampleBlock' className='cont-head-d js-pageMarker-viz'>Example block</span>
                        <p>Use the <code>data-example-number</code> attribute set the example number.</p>
                        <div className='cont-block cont-block-outlined'>
                            <div className='cont-block-body'>
                                <div
                                    className='cont-block cont-block-outlined cont-block-example cont-interactive-example'
                                    data-example-number="1">
                                    <div className='cont-block-head'>
                                        Example 1
                                    </div>
                                    <ExampleBlockBodySmall/>
                                </div>
                            </div>
                            <SyntaxHighlighter language="html" style={{}}
                                               className={"cont-block-code cont-interactive-example"}>
                                {beautifyHTML(`
                                    <div class="cont-block cont-block-example cont-interactive-example" data-example-number="1">
                                        <div class='cont-block-head'>
                                            Example 1
                                        </div>
                                        <div class='cont-block-body'>
                                            ...
                                        </div>
                                    </div>
                                `)}
                            </SyntaxHighlighter>
                        </div>
                        <APItable data={[
                            {
                                option: 'cont-block-example',
                                attr: API_ATTR.CLASS,
                                applyTo: API_APPLY_TO.BLOCK,
                                required: true,
                                description: 'Example block core class'
                            },
                            {
                                option: 'cont-interactive-example',
                                attr: API_ATTR.CLASS,
                                applyTo: API_APPLY_TO.BLOCK,
                                required: true,
                                description: 'Example block interactive class'
                            },
                            {
                                option: 'data-example-number',
                                attr: API_ATTR.DATA,
                                applyTo: API_APPLY_TO.BLOCK,
                                required: true,
                                description: 'Example number'
                            },
                        ]}/>
                        <span id='blockAccordion' className='cont-head-d js-pageMarker-viz'>Block with widths</span>
                        <div className='cont-block cont-block-outlined'>
                            <div className='cont-block-body'>
                                <div className='cont-block cont-block-outlined cont-width-50'>
                                    <div className='cont-block-head'>
                                        Block with widths
                                    </div>
                                    <ExampleBlockBodySmall/>
                                </div>
                            </div>
                            <SyntaxHighlighter language="html" style={{}} className={"cont-block-code"}>
                                {beautifyHTML(`
                                    <div class="cont-block cont-width-50">
                                        <div class="cont-block-head">
                                            Block with accordion functionality
                                        </div>
                                        <div class="cont-block-body">
                                            ...
                                        </div>
                                    </div>
                                `)}
                            </SyntaxHighlighter>
                        </div>
                        <APItable data={[
                            {
                                option: 'cont-width-*',
                                attr: API_ATTR.CLASS,
                                required: false,
                                description: 'Block width percent 10%, 15%, 20%, 25%, 30%, 35%, 40%, 45%, 50%, 55%, 60%, 65%, 70%, 75%, 80%, 85%, 90%, 95%, 100%'
                            },
                        ]}/>
                    </div>
                    <span className='cont-head-c js-pageMarker-viz'>Block colours</span>
                    <div className='js-group-pageMarker'>
                        <span className='cont-head-d js-pageMarker-viz'>Basic block</span>
                        <p>Basic blocks have a header colour based on the main colour variable and a grey
                            background.</p>
                        <div className='cont-block cont-block-outlined'>
                            <div className='cont-block-body'>
                                <div className='cont-block cont-block-basic'>
                                    <div className='cont-block-head'>
                                        Basic block
                                    </div>
                                    <ExampleBlockBody/>
                                </div>
                            </div>
                            <SyntaxHighlighter language="html" style={{}} className={"cont-block-code"}>
                                {beautifyHTML(`
                                    <div class="cont-block cont-block-basic">
                                        <div class="cont-block-head">
                                            ...
                                        </div>
                                        <div class="cont-block-body">
                                            ...
                                        </div>
                                    </div>
                                `)}
                            </SyntaxHighlighter>
                        </div>
                        <APItable data={[
                            {
                                option: 'cont-block-basic',
                                attr: API_ATTR.CLASS,
                                applyTo: API_APPLY_TO.BLOCK,
                                required: true,
                                description: 'Adds basic block styles to a block'
                            },
                        ]}/>
                        <span className='cont-head-d js-pageMarker-viz'>Simple blocks</span>
                        <p>Simple blocks only have a background colour, no header colour. All other text styling
                            displays the same as outside the block.</p>
                        <div className='cont-block cont-block-outlined'>
                            <div className='cont-block-body'>
                                <div className='cont-block cont-block-simple-1'>
                                    <div className='cont-block-head'>
                                        Simple Block 1
                                    </div>
                                    <ExampleBlockBody/>
                                </div>
                                <div className='cont-block cont-block-simple-2'>
                                    <div className='cont-block-head'>
                                        Simple Block 2
                                    </div>
                                    <ExampleBlockBodySmall/>
                                </div>
                                <div className='cont-block cont-block-simple-3'>
                                    <div className='cont-block-head'>
                                        Simple Block 3
                                    </div>
                                    <ExampleBlockBodySmall/>
                                </div>
                                <div className='cont-block cont-block-simple-4'>
                                    <div className='cont-block-head'>
                                        Simple Block 4
                                    </div>
                                    <ExampleBlockBodySmall/>
                                </div>
                                <div className='cont-block cont-block-simple-5'>
                                    <div className='cont-block-head'>
                                        Simple Block 5
                                    </div>
                                    <ExampleBlockBodySmall/>
                                </div>
                                <div className='cont-block cont-block-simple-6'>
                                    <div className='cont-block-head'>
                                        Simple Block 6
                                    </div>
                                    <ExampleBlockBodySmall/>
                                </div>
                                <div className='cont-block cont-block-simple-7'>
                                    <div className='cont-block-head'>
                                        Simple Block 7
                                    </div>
                                    <ExampleBlockBodySmall/>
                                </div>
                                <div className='cont-block cont-block-simple-8'>
                                    <div className='cont-block-head'>
                                        Simple Block 8
                                    </div>
                                    <ExampleBlockBodySmall/>
                                </div>
                                <div className='cont-block cont-block-simple-9'>
                                    <div className='cont-block-head'>
                                        Simple Block 9
                                    </div>
                                    <ExampleBlockBodySmall/>
                                </div>
                                <div className='cont-block cont-block-simple-10'>
                                    <div className='cont-block-head'>
                                        Simple Block 10
                                    </div>
                                    <ExampleBlockBodySmall/>
                                </div>
                            </div>
                            <SyntaxHighlighter language="html" style={{}} className={"cont-block-code"}>
                                {beautifyHTML(`
                                    <div class='cont-block cont-block-simple-*'>
                                        <div class="cont-block-body">
                                            ...
                                        </div>
                                    </div>
                                `)}
                            </SyntaxHighlighter>
                        </div>
                        <APItable data={[
                            {
                                option: 'cont-block-simple-*',
                                attr: API_ATTR.CLASS,
                                applyTo: API_APPLY_TO.BLOCK,
                                required: false,
                                description: 'Adds simple block style 1 - 10 to a block'
                            },
                        ]}/>
                        <span className='cont-head-d js-pageMarker-viz'>Custom blocks</span>
                        <p>Custom blocks have a core colour which is applied to text styles inside the block. This will
                            stop colours clashing if things like tables or lists are used inside the block.</p>
                        <div className='cont-block cont-block-outlined'>
                            <div className='cont-block-body'>
                                <div className='cont-block cont-block-custom-1'>
                                    <div className='cont-block-head'>
                                        Custom Block 1
                                    </div>
                                    <ExampleBlockBody/>
                                </div>
                                <div className='cont-block cont-block-custom-2'>
                                    <div className='cont-block-head'>
                                        Custom Block 2
                                    </div>
                                    <ExampleBlockBody/>
                                </div>
                                <div className='cont-block cont-block-custom-3'>
                                    <div className='cont-block-head'>
                                        Custom Block 3
                                    </div>
                                    <ExampleBlockBody/>
                                </div>
                                <div className='cont-block cont-block-custom-4'>
                                    <div className='cont-block-head'>
                                        Custom Block 4
                                    </div>
                                    <ExampleBlockBody/>
                                </div>
                                <div className='cont-block cont-block-custom-5'>
                                    <div className='cont-block-head'>
                                        Custom Block 5
                                    </div>
                                    <ExampleBlockBody/>
                                </div>
                                <div className='cont-block cont-block-custom-6'>
                                    <div className='cont-block-head'>
                                        Custom Block 6
                                    </div>
                                    <ExampleBlockBody/>
                                </div>
                                <div className='cont-block cont-block-custom-7'>
                                    <div className='cont-block-head'>
                                        Custom Block 7
                                    </div>
                                    <ExampleBlockBody/>
                                </div>
                                <div className='cont-block cont-block-custom-8'>
                                    <div className='cont-block-head'>
                                        Custom Block 8
                                    </div>
                                    <ExampleBlockBody/>
                                </div>
                                <div className='cont-block cont-block-custom-9'>
                                    <div className='cont-block-head'>
                                        Custom Block 9
                                    </div>
                                    <ExampleBlockBody/>
                                </div>
                                <div className='cont-block cont-block-custom-10'>
                                    <div className='cont-block-head'>
                                        Custom Block 10
                                    </div>
                                    <ExampleBlockBody/>
                                </div>
                            </div>
                            <SyntaxHighlighter language="html" style={{}} className={"cont-block-code"}>
                                {beautifyHTML(`
                                    <div class='cont-block cont-block-custom-*'>
                                        <div class="cont-block-head">
                                            ...
                                        </div>
                                        <div class="cont-block-body">
                                            ...
                                        </div>
                                    </div>
                                `)}
                            </SyntaxHighlighter>
                        </div>
                        <APItable data={[
                            {
                                option: 'cont-block-custom-*',
                                attr: API_ATTR.CLASS,
                                applyTo: API_APPLY_TO.BLOCK,
                                required: false,
                                description: 'Adds custom block style 1 - 10 to a block'
                            },
                        ]}/>
                    </div>
                </div>
                <span className='cont-head-b js-pageMarker-viz'>Grid</span>
                <div className='js-group-pageMarker'>
                    <span className='cont-head-c js-pageMarker-viz'>Grid options</span>
                    <p>The grid system can adapt with screen sizes, which will allow resizing on smaller screens.</p>
                    <ul className='cont-list-disc'>
                        <li>No resizing</li>
                        <li>Small (sm)</li>
                        <li>Medium (md)</li>
                    </ul>
                    <p>The grid changes across these breakpoints:</p>
                    <table className="cont-table cont-table-basic">
                        <tbody>
                        <tr>
                            <td scope="row">Container <code>max-width</code></td>
                            <td>None (auto)</td>
                            <td>540px</td>
                            <td>768px</td>
                        </tr>
                        <tr>
                            <td scope="row">Class prefix</td>
                            <td>cont-grid-col</td>
                            <td>cont-grid-col-sm</td>
                            <td>cont-grid-col-md</td>
                        </tr>
                        <tr>
                            <td scope="row"># of columns</td>
                            <td colSpan="3">12</td>
                        </tr>
                        </tbody>
                    </table>
                    <span className='cont-head-c js-pageMarker-viz'>Equal-width</span>
                    <div className="cont-block cont-block-outlined">
                        <div className="cont-block-body">
                            <div className="cont-grid-row cont-grid-row-demo">
                                <div className="cont-grid-col-sm">1 of 2</div>
                                <div className="cont-grid-col-sm">2 of 2</div>
                            </div>
                            <div className="cont-grid-row cont-grid-row-demo">
                                <div className="cont-grid-col">1 of 3</div>
                                <div className="cont-grid-col">2 of 3</div>
                                <div className="cont-grid-col">3 of 3</div>
                            </div>
                        </div>
                        <SyntaxHighlighter language="html" style={{}} className={"cont-block-code"}>
                            {beautifyHTML(`
                                <div class="cont-grid-row">
                                    <div class="cont-grid-col-sm">1 of 2</div>
                                    <div class="cont-grid-col-sm">2 of 2</div>
                                </div>
                                <div class="cont-grid-row">
                                    <div class="cont-grid-col">1 of 3</div>
                                    <div class="cont-grid-col">2 of 3</div>
                                    <div class="cont-grid-col">3 of 3</div>
                                </div>
                            `)}
                        </SyntaxHighlighter>
                    </div>
                    <span className='cont-head-c js-pageMarker-viz'>Setting one column width</span>
                    <p></p>
                    <div className="cont-block cont-block-outlined">
                        <div className="cont-block-body">
                            <div className="cont-grid-row cont-grid-row-demo">
                                <div className="cont-grid-col-sm-4">1 of 2</div>
                                <div className="cont-grid-col-sm">2 of 2</div>
                            </div>
                            <div className="cont-grid-row cont-grid-row-demo">
                                <div className="cont-grid-col">1 of 3</div>
                                <div className="cont-grid-col-6">2 of 3</div>
                                <div className="cont-grid-col">3 of 3</div>
                            </div>
                        </div>
                        <SyntaxHighlighter language="html" style={{}} className={"cont-block-code"}>
                            {beautifyHTML(`
                                 <div class="cont-grid-row">
                                    <div class="cont-grid-col-sm-4">1 of 2</div>
                                    <div class="cont-grid-col-sm">2 of 2</div>
                                </div>
                                <div class="cont-grid-row">
                                    <div class="cont-grid-col">1 of 3</div>
                                    <div class="cont-grid-col-6">2 of 3</div>
                                    <div class="cont-grid-col">3 of 3</div>
                                </div>
                            `)}
                        </SyntaxHighlighter>
                    </div>
                    <span className='cont-head-c js-pageMarker-viz'>Grid widths</span>
                    <div className="cont-block cont-block-outlined">
                        <div className="cont-block-body">
                            <div className="cont-grid-row cont-grid-row-demo">
                                <div className="cont-grid-col">-col (auto sized)</div>
                            </div>
                            <div className="cont-grid-row cont-grid-row-demo">
                                <div className="cont-grid-col-1">-col-1</div>
                                <div className="cont-grid-col-11">-col-11</div>
                            </div>
                            <div className="cont-grid-row cont-grid-row-demo">
                                <div className="cont-grid-col-2">-col-2</div>
                                <div className="cont-grid-col-10">-col-10</div>
                            </div>
                            <div className="cont-grid-row cont-grid-row-demo">
                                <div className="cont-grid-col-3">-col-3</div>
                                <div className="cont-grid-col-9">-col-9</div>
                            </div>
                            <div className="cont-grid-row cont-grid-row-demo">
                                <div className="cont-grid-col-4">-col-4</div>
                                <div className="cont-grid-col-8">-col-8</div>
                            </div>
                            <div className="cont-grid-row cont-grid-row-demo">
                                <div className="cont-grid-col-5">-col-5</div>
                                <div className="cont-grid-col-7">-col-7</div>
                            </div>
                            <div className="cont-grid-row cont-grid-row-demo">
                                <div className="cont-grid-col-6">-col-6</div>
                                <div className="cont-grid-col-6">-col-6</div>
                            </div>
                            <div className="cont-grid-row cont-grid-row-demo">
                                <div className="cont-grid-col-12">-col-12</div>
                            </div>
                        </div>
                    </div>
                    <p>All * values can be replaced with <code>sm</code> or <code>md</code> for column wrapping at
                        certain widths.</p>
                    <APItable data={[
                        {option: 'cont-grid-row', attr: API_ATTR.CLASS, required: true, description: 'Wrapping class'},
                        {
                            option: 'cont-grid-col-1, cont-grid-col-*-1',
                            attr: API_ATTR.CLASS,
                            required: false,
                            description: '8.3% column width'
                        },
                        {
                            option: 'cont-grid-col-2, cont-grid-col-*-2',
                            attr: API_ATTR.CLASS,
                            required: false,
                            description: '16.6% column width'
                        },
                        {
                            option: 'cont-grid-col-3, cont-grid-col-*-3',
                            attr: API_ATTR.CLASS,
                            required: false,
                            description: '25% column width'
                        },
                        {
                            option: 'cont-grid-col-4, cont-grid-col-*-4',
                            attr: API_ATTR.CLASS,
                            required: false,
                            description: '33.3% column width'
                        },
                        {
                            option: 'cont-grid-col-5, cont-grid-col-*-5',
                            attr: API_ATTR.CLASS,
                            required: false,
                            description: '41.6% column width'
                        },
                        {
                            option: 'cont-grid-col-6, cont-grid-col-*-6',
                            attr: API_ATTR.CLASS,
                            required: false,
                            description: '50% column width'
                        },
                        {
                            option: 'cont-grid-col-7, cont-grid-col-*-7',
                            attr: API_ATTR.CLASS,
                            required: false,
                            description: '58.3% column width'
                        },
                        {
                            option: 'cont-grid-col-8, cont-grid-col-*-8',
                            attr: API_ATTR.CLASS,
                            required: false,
                            description: '66.6% column width'
                        },
                        {
                            option: 'cont-grid-col-9, cont-grid-col-*-9',
                            attr: API_ATTR.CLASS,
                            required: false,
                            description: '75% column width'
                        },
                        {
                            option: 'cont-grid-col-10, cont-grid-col-*-10',
                            attr: API_ATTR.CLASS,
                            required: false,
                            description: '83.3% column width'
                        },
                        {
                            option: 'cont-grid-col-11, cont-grid-col-*-11',
                            attr: API_ATTR.CLASS,
                            required: false,
                            description: '91.6% column width'
                        },
                        {
                            option: 'cont-grid-col-12, cont-grid-col-*-12',
                            attr: API_ATTR.CLASS,
                            required: false,
                            description: '100% column width'
                        },
                    ]}/>
                </div>
                <span className='cont-head-b js-pageMarker-viz'>Columns</span>
                <div className='js-group-pageMarker'>
                    <span className='cont-head-c js-pageMarker-viz'>Basic column layout</span>
                    <p>A 2 column layout is the default.</p>
                    <div className="cont-block cont-block-outlined">
                        <div className='cont-block-body'>
                            <div className='cont-column-group'>
                                <div className='cont-column-item'>
                                    <figure className='cont-img'>
                                        <img src="/users/generalFiles/images/sample.jpg"/>
                                    </figure>
                                </div>
                                <div className='cont-column-item'>
                                    <div className='cont-block cont-block-simple-1'>
                                        <div className='cont-block-body'>
                                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
                                                tempor incididunt ut labore et dolore magna aliqua.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <SyntaxHighlighter language="html" style={{}} className={"cont-block-code"}>
                            {beautifyHTML(`
                                <div class="cont-column-group">
                                    <div class="cont-column-item">
                                        <!-- column content -->
                                    </div>
                                    <div class="cont-column-item">
                                        <!-- column content -->
                                    </div>
                                </div>
                            `)}
                        </SyntaxHighlighter>
                    </div>
                    <span className='cont-head-c js-pageMarker-viz'>Multiple column groups</span>
                    <p>If you add more <code>cont-column-item</code> to the <code>cont-column-group</code>, they will
                        wrap to maintain the 2 column layout</p>
                    <div className="cont-block cont-block-outlined">
                        <div className='cont-block-body'>
                            <div className='cont-column-group'>
                                <div className='cont-column-item'>
                                    <figure className='cont-img'>
                                        <img src="/users/generalFiles/images/sample.jpg"/>
                                        <figcaption>
                                            <p className='cont-caption'>
                                                <span className='cont-caption-source'>Source 2.12</span> An ancient
                                                Egyptian
                                                bas-relief of the god Horus</p>
                                        </figcaption>
                                    </figure>
                                </div>
                                <div className='cont-column-item'>
                                    <div className='cont-block cont-block-simple-1'>
                                        <div className='cont-block-body'>
                                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
                                                tempor incididunt ut labore et dolore magna aliqua.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className='cont-column-item'>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                                        incididunt ut labore et dolore magna aliqua.</p>
                                </div>
                                <div className='cont-column-item'>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                                        incididunt ut labore et dolore magna aliqua.</p>
                                </div>
                                <div className='cont-column-item'>
                                    <div className='cont-block cont-block-simple-2'>
                                        <div className='cont-block-body'>
                                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
                                                tempor incididunt ut labore et dolore magna aliqua.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <SyntaxHighlighter language="html" style={{}} className={"cont-block-code"}>
                            {beautifyHTML(`
                                <div class="cont-columns">
                                    <div class="cont-column">
                                        <!-- column content -->
                                    </div>
                                    <div class="cont-column">
                                        <!-- column content -->
                                    </div>
                                    <div class="cont-column">
                                        <!-- column content -->
                                    </div>
                                    <div class="cont-column">
                                        <!-- column content -->
                                    </div>
                                    <div class="cont-column">
                                        <!-- column content -->
                                    </div>
                                </div>
                            `)}
                        </SyntaxHighlighter>
                    </div>
                </div>
                <APItable data={[
                    {
                        option: 'cont-column-group',
                        attr: API_ATTR.CLASS,
                        required: true,
                        description: 'Container for arranging the columns'
                    },
                    {
                        option: 'cont-column-group-nowrap',
                        attr: API_ATTR.CLASS,
                        required: true,
                        description: 'Used instead of cont-column-group, works the same but the columns wont wrap on small screens'
                    },
                    {
                        option: 'cont-column-item',
                        attr: API_ATTR.CLASS,
                        required: true,
                        description: 'Individual items within the multi-column layout'
                    },
                ]}/>
                <span className='cont-head-b js-pageMarker-viz'>Interactive content</span>
                <div className='js-group-pageMarker'>
                    <span id='showHideContent' className='cont-head-c js-pageMarker-viz'>Toggle questions answers</span>
                    <p>Use the <strong>data-toggle-name</strong> attribute set the show/hide button name.</p>
                    <div className="cont-block cont-block-outlined">
                        <div className='cont-block-body'>
                            <div className="cont-block-body">
                                <div className="cont-block-toggle" data-toggle-name="answers">
                                    <ol>
                                        <li>
                                            <p>Question 1 content.</p>
                                            <div className="cont-toggle-item">Answer 1 content.</div>
                                        </li>
                                        <li>
                                            <p>Question 2 content.</p>
                                            <div className="cont-toggle-item">Answer 2 content.</div>
                                        </li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                        <SyntaxHighlighter language="html" style={{}} className={"cont-block-code"}>
                            {beautifyHTML(`
                                <div class="cont-block-toggle" data-toggle-name="answers">
                                    <ol>
                                        <li>
                                            <p>Question 1 content.</p>
                                            <div class="cont-toggle-item">Answer 1 content.</div>
                                        </li>
                                        <li>
                                            <p>Question 2 content.</p>
                                            <div class="cont-toggle-item">Answer 2 content.</div>
                                        </li>
                                    </ol>
                                </div>
                            `)}
                        </SyntaxHighlighter>
                    </div>
                    <APItable data={[
                        {
                            option: 'cont-block-toggle',
                            attr: API_ATTR.CLASS,
                            required: true,
                            description: 'Core show/hide wrapper class'
                        },
                        {
                            option: 'cont-toggle-item',
                            attr: API_ATTR.CLASS,
                            required: true,
                            description: 'Show/hide individual content'
                        },
                    ]}/>
                    <span className='cont-head-c js-pageMarker-viz'>Content in dialog</span>
                    <div className='js-group-pageMarker'>
                        <span className='cont-head-d js-pageMarker-viz'>Basic content in dialog</span>
                        <p>Optionally use the <strong>data-dialog-name</strong> attribute set the show dialog button
                            name.</p>
                        <div className="cont-block cont-block-outlined">
                            <div className='cont-block-body'>
                                <div className="cont-block-dialog" data-dialog-name="Extra notes">
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                                        incididunt ut labore et dolore magna aliqua. Urna duis convallis convallis
                                        tellus id interdum velit laoreet.</p>
                                </div>
                            </div>
                            <SyntaxHighlighter language="html" style={{}} className={"cont-block-code"}>
                                {beautifyHTML(`
                                    <div class="cont-block-dialog"  data-dialog-name="Extra notes">
                                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Urna duis convallis convallis tellus id interdum velit laoreet.</p>
                                    </div>
                                `)}
                            </SyntaxHighlighter>
                        </div>
                        <APItable data={[
                            {
                                option: 'cont-block-dialog',
                                attr: API_ATTR.CLASS,
                                required: true,
                                description: 'Core dialog class'
                            },
                            {
                                option: 'data-dialog-name',
                                attr: API_ATTR.DATA,
                                required: false,
                                description: 'Name of dialog link button'
                            },
                        ]}/>
                        <span id='teacherNotesDialog' className='cont-head-d js-pageMarker-viz'>Teacher notes content in dialog</span>
                        <div className="cont-block cont-block-outlined">
                            <div className='cont-block-body'>
                                <div className="cont-block-dialog cont-teacher-notes">
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                                        incididunt ut labore et dolore magna aliqua. Urna duis convallis convallis
                                        tellus id interdum velit laoreet.</p>
                                </div>
                            </div>
                            <SyntaxHighlighter language="html" style={{}} className={"cont-block-code"}>
                                {beautifyHTML(`
                                    <div class="cont-block-dialog cont-teacher-notes">
                                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Urna duis convallis convallis tellus id interdum velit laoreet.</p>
                                    </div>
                                `)}
                            </SyntaxHighlighter>
                        </div>
                        <APItable data={[
                            {
                                option: 'cont-block-dialog',
                                attr: API_ATTR.CLASS,
                                required: true,
                                description: 'Core dialog class'
                            },
                            {
                                option: 'cont-teacher-notes',
                                attr: API_ATTR.CLASS,
                                required: false,
                                description: 'Use teacher notes icon link button'
                            },
                        ]}/>
                    </div>
                    <span id='imageZoom' className='cont-head-c js-pageMarker-viz'>Image Zoom</span>
                    <div className='js-group-pageMarker'>
                        <div className="cont-block cont-block-outlined">
                            <div className='cont-block-body'>
                                <figure className="cont-img cont-img-zoom">
                                    <img src="/users/generalFiles/images/sample.jpg"/>
                                    <figcaption>
                                        <p className="cont-caption"><span
                                            className="cont-caption-source">Source 2.12</span> An ancient Egyptian
                                            bas-relief of the god Horus</p>
                                    </figcaption>
                                </figure>
                            </div>
                            <SyntaxHighlighter language="html" style={{}} className={"cont-block-code"}>
                                {beautifyHTML(`
                                    <figure class="cont-img cont-img-zoom">
                                        <img src="/users/generalFiles/images/sample.jpg"/>
                                        <figcaption class="cont-caption">
                                            <span class="cont-caption-source">Source 2.12</span> An ancient Egyptian bas-relief of the god Horus
                                        </figcaption>
                                    </figure>
                                `)}
                            </SyntaxHighlighter>
                        </div>
                        <APItable data={[
                            {
                                option: 'cont-img',
                                attr: API_ATTR.CLASS,
                                required: true,
                                description: 'Core image class default 75% width'
                            },
                            {
                                option: 'cont-img-zoom',
                                attr: API_ATTR.CLASS,
                                required: true,
                                description: 'Enable image zoom functionality'
                            },
                        ]}/>
                    </div>
                </div>
                <span className='cont-head-b js-pageMarker-viz'>Questions</span>
                <ol>
                    <li>Questions coded for standalone usage in diagnostics or exam generator should be placed in
                        individual &lt;div&gt; tags (see examples below)
                    </li>
                    <li>Questions coded for use in sets (exercises and quizzes) should be placed in an ordered list. The &lt;ol&gt;
                        tag should use the "cont-question-group" class and each individual question should be placed in an &lt;li&gt; tag (see examples below)
                    </li>

                    <li>Do <strong>not</strong> include any elements or text between ordered list elements and and list
                        items element.
                    </li>
                    <li>Do <strong>not</strong> include <i>assessment</i> or <i>generalProblem</i> classes on any items.</li>
                    <li>Do <strong>not</strong> split question sets into separate top-level ordered lists.</li>
                    <li>
                        <i>Question cont-question</i> elements should <b>only</b> contain the following child elements (as needed):
                        <ol className="cont-list-lower-alpha">
                            <li>
                                <i>cont-question-head</i>
                            </li>
                            <li>
                                <i>cont-question-body</i>
                            </li>
                            <li>
                                <i>cont-question-group</i>
                            </li>
                            <li>
                                <i>cont-question-solution</i> (For non-automarked questions)
                            </li>
                            <li>
                                <i>cont-question-worked-solution</i> (For non-automarked questions)
                            </li>
                        </ol>
                        <p>All other question elements should be contained within one of these elements.</p>
                    </li>
                    <li>
                        Question <i>cont-question</i> elements must have either a <i>&lt;div class="cont-question-body"&gt;</i> or <i>&lt;ol class="cont-question-group"&gt;</i> child element, but not both.
                    </li>
                    <li>
                        If a Question <i>cont-question</i> element includes a <i>cont-question-group</i> child element, it may optionally also includes a <i>cont-question-head</i> child element.
                    </li>
                    <li>Question <i>cont-question</i> elements should <b>not</b> contain both a <i>cont-question-body</i> and
                        a <i>cont-question-group</i> element. Only one of these elements should be used.
                    </li>
                    <li>
                        <strong>Automarked questions</strong> (e.g., <i>multiple-choice</i>, <i>short-answer</i>, <i>drag-and-drop</i>) must have all interactive elements (like <i>&lt;input&gt;</i> or <i>&lt;select&gt;</i>) placed inside the <i>cont-question-body</i> element. These question types should <strong>not</strong> contain a <i>cont-question-solution</i> or <i>cont-question-worked-solution</i> element.
                    </li>
                </ol>
                <div className='js-group-pageMarker'>
                    <span className='cont-head-c js-pageMarker-viz'>How to code the different question types and use them as stand alone or in a set </span>
                    <div className='js-group-pageMarker'>
                        <span className='cont-head-d js-pageMarker-viz'>Multiple-choice question</span>
                        <div className="cont-block cont-block-outlined">
                            <div className='cont-block-body'>
                                <div className="cont-block-body">
                                    <div className="cont-question" data-question-level="2"
                                         data-question-type="multiple-choice" data-question-number="32">
                                        <div className="cont-question-body">
                                            <p>Multiple choice question?</p>
                                            <ol className="cont-question-options">
                                                <li><input name="demoMCQ" checked type="radio" onChange={() => {
                                                }}/>Option a (correct option)
                                                </li>
                                                <li><input name="demoMCQ" type="radio" onChange={() => {
                                                }}/>Option b
                                                </li>
                                                <li><input name="demoMCQ" type="radio" onChange={() => {
                                                }}/>Option c
                                                </li>
                                                <li><input name="demoMCQ" type="radio" onChange={() => {
                                                }}/>Option d
                                                </li>
                                                <li><input name="demoMCQ" type="radio" onChange={() => {
                                                }}/>Option e
                                                </li>
                                            </ol>
                                        </div>
                                        <p className="cont-question-solution">Explain the correct option</p>
                                    </div>
                                </div>
                            </div>
                            <SyntaxHighlighter language="html" style={{}} className={"cont-block-code"}>
                                {beautifyHTML(`
                                    <!--For use standalone-->
                                    <div class="cont-question" data-question-level="2" data-question-type="multiple-choice" data-question-number="32">
                                        <div class="cont-question-body">
                                            <p>Multiple choice question?</p>
                                            <ol class="cont-question-options">
                                                <li><input checked type="radio"/>Option a (correct option)</li>
                                                <li><input type="radio"/>Option b</li>
                                                <li><input type="radio"/>Option c</li>
                                                <li><input type="radio"/>Option d</li>
                                                <li><input type="radio"/>Option e</li>
                                            </ol>
                                        </div>
                                        <p class="cont-question-solution">Explain the correct option</p>
                                    </div>
                                    
                                    <!--For use in a set-->
                                    <li class="cont-question" data-question-level="2" data-question-type="multiple-choice">
                                        <div class="cont-question-body">
                                            <p>Multiple choice question?</p>
                                            <ol class="cont-question-options">
                                                <li><input checked type="radio"/>Option a (correct option)</li>
                                                <li><input type="radio"/>Option b</li>
                                                <li><input type="radio"/>Option c</li>
                                                <li><input type="radio"/>Option d</li>
                                                <li><input type="radio"/>Option e</li>
                                            </ol>
                                        </div>
                                        <p class="cont-question-solution">Explain the correct option</p>
                                    </li>
                                `)}
                            </SyntaxHighlighter>
                        </div>
                        <APItable data={[
                            {
                                option: 'cont-question',
                                attr: API_ATTR.CLASS,
                                required: true,
                                description: 'Core question class'
                            },
                            {
                                option: 'cont-question-body',
                                attr: API_ATTR.CLASS,
                                required: true,
                                description: 'Question body content'
                            },
                            {
                                option: 'cont-question-options',
                                attr: API_ATTR.CLASS,
                                required: false,
                                description: 'Required for multiple choice questions'
                            },
                            {
                                option: 'cont-question-solution',
                                attr: API_ATTR.CLASS,
                                required: false,
                                description: 'Question solution'
                            },
                            {
                                option: 'cont-question-worked-solution',
                                attr: API_ATTR.CLASS,
                                required: false,
                                description: 'Question worked solution'
                            },
                            {
                                option: 'data-question-type',
                                attr: API_ATTR.DATA,
                                required: true,
                                description: 'multiple-choice|fill-in-the-blank|drag-and-drop|highlight|alternative|short-answer|extended-response|true-false'
                            },
                            {
                                option: 'data-question-level',
                                attr: API_ATTR.DATA,
                                required: false,
                                description: 'Difficulty level: 1,2, 3, 4'
                            },
                            {
                                option: 'data-question-number',
                                attr: API_ATTR.DATA,
                                required: false,
                                description: 'Question number'
                            },
                        ]}/>
                        <span className='cont-head-d js-pageMarker-viz'>Multiple-choice question select list</span>
                        <div className="cont-block cont-block-outlined">
                            <div className='cont-block-body'>
                                <div className="cont-block-body">
                                    <div className="cont-question" data-question-level="2"
                                         data-question-type="multiple-choice">
                                        <div className="cont-question-body">
                                            <p>Multiple choice question?</p>
                                            <select className="cont-question-options" defaultValue={'2'}>
                                                <option value={'1'}>Option a</option>
                                                <option value={'2'}>Option b</option>
                                            </select>
                                        </div>
                                        <p className="cont-question-solution">Explain the correct option</p>
                                    </div>
                                </div>
                            </div>
                            <SyntaxHighlighter language="html" style={{}} className={"cont-block-code"}>
                                {beautifyHTML(`
                                    <!--For use standalone-->
                                    <div class="cont-question" data-question-level="2" data-question-type="multiple-choice">
                                        <div class="cont-question-body">
                                            <p>Multiple choice question?</p>
                                            <select class="cont-question-options">
                                                <option>Option a</option>
                                                <option selected>Option b</option>
                                            </select>
                                        </div>
                                        <p class="cont-question-solution">Explain the correct option</p>
                                    </div>
                                    
                                    <!--For use in a set-->
                                    <li class="cont-question" data-question-level="2" data-question-type="multiple-choice">
                                        <div class="cont-question-body">
                                            <p>Multiple choice question?</p>
                                            <select class="cont-question-options">
                                                <option>Option a</option>
                                                <option selected>Option b</option>
                                            </select>
                                        </div>
                                        <p class="cont-question-solution">Explain the correct option</p>
                                    </li>
                                `)}
                            </SyntaxHighlighter>
                        </div>
                        <span className='cont-head-d js-pageMarker-viz'>Multiple-choice question multiple options</span>
                        <div className="cont-block cont-block-outlined">
                            <div className='cont-block-body'>
                                <div className="cont-block-body">
                                    <div className="cont-question" data-question-level="2"
                                         data-question-type="multiple-choice">
                                        <div className="cont-question-body">
                                            <p>Multiple choice question?</p>
                                            <ol className="cont-question-options">
                                                <li><input type="checkbox" onChange={() => {
                                                }}/>Option a
                                                </li>
                                                <li><input type="checkbox" onChange={() => {
                                                }} checked/>Option b (correct option)
                                                </li>
                                                <li><input type="checkbox" onChange={() => {
                                                }}/>Option c
                                                </li>
                                                <li><input type="checkbox" onChange={() => {
                                                }}/>Option d
                                                </li>
                                                <li><input type="checkbox" onChange={() => {
                                                }} checked/>Option e (correct option)
                                                </li>
                                            </ol>
                                        </div>
                                        <p className="cont-question-solution">Explain the correct option</p>
                                    </div>
                                </div>
                            </div>
                            <SyntaxHighlighter language="html" style={{}} className={"cont-block-code"}>
                                {beautifyHTML(`
                                    <!--For use standalone-->
                                    <div class="cont-question" data-question-level="2" data-question-type="multiple-choice">
                                        <p>Multiple choice question?</p>
                                        <ol class="cont-question-options">
                                            <li><input type="checkbox"/>Option a</li>
                                            <li><input type="checkbox" checked/>Option b (correct option)</li>
                                            <li><input type="checkbox"/>Option c</li>
                                            <li><input type="checkbox"/>Option d</li>
                                            <li><input type="checkbox" checked/>Option e (correct option)</li>
                                        </ol>
                                        <p class="cont-question-solution">Explain the correct option</p>
                                    </div>
                                    
                                    <!--For use in a set-->
                                    <li class="cont-question" data-question-level="2" data-question-type="multiple-choice">
                                        <div class="cont-question-body">
                                            <p>Multiple choice question?</p>
                                            <ol class="cont-question-options">
                                                <li><input type="checkbox"/>Option a</li>
                                                <li><input type="checkbox" checked/>Option b (correct option)</li>
                                                <li><input type="checkbox"/>Option c</li>
                                                <li><input type="checkbox"/>Option d</li>
                                                <li><input type="checkbox" checked/>Option e (correct option)</li>
                                            </ol>
                                        </div>
                                        <p class="cont-question-solution">Explain the correct option</p>
                                    </li>
                                `)}
                            </SyntaxHighlighter>
                        </div>
                        <span className='cont-head-d js-pageMarker-viz'>Drag-and-drop question</span>
                        <div className="cont-block cont-block-outlined">
                            <div className='cont-block-body'>
                                <div className="cont-block-body">
                                    <div className="cont-question" data-question-level="2" data-question-type="drag-and-drop">
                                        <div className="cont-question-body">
                                            <div className="js-q-dnd-match">
                                                <table>
                                                    <tbody>
                                                    <tr>
                                                        <td>
                                                            <p></p>
                                                            <p>The path Earth makes around the Sun.</p>
                                                        </td>
                                                        <td className="js-drag-area"><span
                                                            className="js-drag-obj">Orbit</span></td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <p></p>
                                                            <p>The shape of the path that Earth makes around the
                                                                Sun.</p>
                                                        </td>
                                                        <td className="js-drag-area"><span
                                                            className="js-drag-obj">Elliptical</span></td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <p></p>
                                                            <p>The complete movement of Earth around the sun in 365
                                                                \(\displaystyle\dfrac {1}{4}\) days.</p>
                                                        </td>
                                                        <td className="js-drag-area"><span
                                                            className="js-drag-obj">Revolution</span></td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <p></p>
                                                            <p>A year with an extra day; happens every four years.</p>
                                                        </td>
                                                        <td className="js-drag-area"><span className="js-drag-obj"
                                                                                           mce-data-marked="1">Leap year</span>
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <SyntaxHighlighter language="html" style={{}} className={"cont-block-code"}>
                                {beautifyHTML(`
                                    <!--For use standalone-->
                                    <div class="cont-question" data-question-level="2" data-question-type="drag-and-drop">
                                        <div class="cont-question-body">
                                            <div class="js-q-dnd-match">
                                                <table>
                                                    <tbody>
                                                    <tr>
                                                        <td>
                                                            <p></p>
                                                            <p>The path Earth makes around the Sun.</p>
                                                        </td>
                                                        <td class="js-drag-area"><span class="js-drag-obj">Orbit</span></td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <p></p>
                                                            <p>The shape of the path that Earth makes around the
                                                                Sun.</p>
                                                        </td>
                                                        <td class="js-drag-area"><span class="js-drag-obj">Elliptical</span></td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <p></p>
                                                            <p>The complete movement of Earth around the sun in 365
                                                                \\(\\displaystyle\\dfrac {1}{4}\\) days.</p>
                                                        </td>
                                                        <td class="js-drag-area"><span class="js-drag-obj">Revolution</span></td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <p></p>
                                                            <p>A year with an extra day; happens every four years.</p>
                                                        </td>
                                                        <td class="js-drag-area"><span class="js-drag-obj">Leap year</span></td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <!--For use in a set-->
                                    <li class="cont-question" data-question-level="2" data-question-type="drag-and-drop">
                                        <div class="cont-question-body">
                                            <div class="js-q-dnd-match">
                                                <table>
                                                    <tbody>
                                                    <tr>
                                                        <td>
                                                            <p></p>
                                                            <p>The path Earth makes around the Sun.</p>
                                                        </td>
                                                        <td class="js-drag-area"><span class="js-drag-obj">Orbit</span></td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <p></p>
                                                            <p>The shape of the path that Earth makes around the
                                                                Sun.</p>
                                                        </td>
                                                        <td class="js-drag-area"><span class="js-drag-obj">Elliptical</span></td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <p></p>
                                                            <p>The complete movement of Earth around the sun in 365
                                                                \\(\\displaystyle\\dfrac {1}{4}\\) days.</p>
                                                        </td>
                                                        <td class="js-drag-area"><span class="js-drag-obj">Revolution</span></td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <p></p>
                                                            <p>A year with an extra day; happens every four years.</p>
                                                        </td>
                                                        <td class="js-drag-area"><span class="js-drag-obj">Leap year</span></td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </li>
                                `)}
                            </SyntaxHighlighter>
                        </div>
                        <span className='cont-head-d js-pageMarker-viz'>Highlight question</span>
                        <div className="cont-block cont-block-outlined">
                            <div className='cont-block-body'>
                                <div className="cont-block-body">
                                    <div className="cont-question" data-question-level="2" data-question-type="highlight">
                                        <div className="cont-question-body">
                                            <div className="js-q-highlight">Weekends are always busy in our household,
                                                and <span className="highlight-selected"
                                                          data-feedback="Saturday">saturday</span> mornings are the
                                                worst &ndash; particularly today. Harrison and Fiona both play <span
                                                    className="highlight-selected"
                                                    data-feedback="cricket">Cricket</span>, but their matches were on
                                                opposite ends of <span className="highlight-selected"
                                                                       data-feedback="town">Town</span>. Dad&rsquo;s car
                                                wouldn&rsquo;t start, so he borrowed <span
                                                    className="highlight-selected"
                                                    data-feedback="Mum's">mum's</span> Honda to drive them while she
                                                waited for the <span className="highlight-selected"
                                                                     data-feedback="NRMA">Nrma</span>. Then <span
                                                    className="highlight-selected" data-feedback="Peta">peta</span> got
                                                a call that there were some casual hours for her at Coles, so she had to
                                                run for the <span className="highlight-selected"
                                                                  data-feedback="bus">Bus</span>. I caught the train to
                                                my <span className="highlight-selected"
                                                         data-feedback="violin">Violin</span> lesson, but the car was
                                                fixed in time for Mum to pick me up and drop me at <span
                                                    className="highlight-selected" data-feedback="Hoyts">hoyts</span> to
                                                see a movie with Arash and Kimberley.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <SyntaxHighlighter language="html" style={{}} className={"cont-block-code"}>
                                {beautifyHTML(`
                                    <!--For use standalone-->
                                    <div class="cont-question" data-question-level="2" data-question-type="highlight">
                                        <div class="cont-question-body">
                                            <div class="js-q-highlight">Weekends are always busy in our household, and <span class="highlight-selected" data-feedback="Saturday">saturday</span> mornings are the worst &ndash; particularly today. Harrison and Fiona both play <span class="highlight-selected" data-feedback="cricket">Cricket</span>, but their matches were on opposite ends of <span class="highlight-selected" data-feedback="town">Town</span>. Dad&rsquo;s car wouldn&rsquo;t start, so he borrowed <span class="highlight-selected" data-feedback="Mum's">mum's</span> Honda to drive them while she waited for the <span class="highlight-selected" data-feedback="NRMA">Nrma</span>. Then <span class="highlight-selected" data-feedback="Peta">peta</span> got a call that there were some casual hours for her at Coles, so she had to run for the <span class="highlight-selected" data-feedback="bus">Bus</span>. I caught the train to my <span class="highlight-selected" data-feedback="violin">Violin</span> lesson, but the car was fixed in time for Mum to pick me up and drop me at <span class="highlight-selected" data-feedback="Hoyts">hoyts</span> to see a movie with Arash and Kimberley.</div>
                                        </div>
                                    </div>
                                    
                                    <!--For use in a set-->
                                    <li class="cont-question" data-question-level="2" data-question-type="highlight">
                                        <div class="cont-question-body">
                                            <div class="js-q-highlight">Weekends are always busy in our household, and <span class="highlight-selected" data-feedback="Saturday">saturday</span> mornings are the worst &ndash; particularly today. Harrison and Fiona both play <span class="highlight-selected" data-feedback="cricket">Cricket</span>, but their matches were on opposite ends of <span class="highlight-selected" data-feedback="town">Town</span>. Dad&rsquo;s car wouldn&rsquo;t start, so he borrowed <span class="highlight-selected" data-feedback="Mum's">mum's</span> Honda to drive them while she waited for the <span class="highlight-selected" data-feedback="NRMA">Nrma</span>. Then <span class="highlight-selected" data-feedback="Peta">peta</span> got a call that there were some casual hours for her at Coles, so she had to run for the <span class="highlight-selected" data-feedback="bus">Bus</span>. I caught the train to my <span class="highlight-selected" data-feedback="violin">Violin</span> lesson, but the car was fixed in time for Mum to pick me up and drop me at <span class="highlight-selected" data-feedback="Hoyts">hoyts</span> to see a movie with Arash and Kimberley.</div>
                                        </div>
                                    </li>
                                `)}
                            </SyntaxHighlighter>
                        </div>
                        <span className='cont-head-d js-pageMarker-viz'>Alternative question</span>
                        <div className="cont-block cont-block-outlined">
                            <div className='cont-block-body'>
                                <div className="cont-block-body">
                                    <div className="cont-question" data-question-level="2" data-question-type="alternative">
                                        <div className="cont-question-body">
                                            <p>Mai has applied for special leave to appeal a decision made by the
                                                FCFCOA.</p>
                                            <select className="js-q-choice">
                                                <option selected="selected">High Court</option>
                                                <option>Federal Court</option>
                                                <option>Federal Circuit and Family Court</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <SyntaxHighlighter language="html" style={{}} className={"cont-block-code"}>
                            {beautifyHTML(`
                                    <!--For use standalone-->
                                    <div class="cont-question" data-question-level="2" data-question-type="alternative">
                                        <div class="cont-question-body">
                                            <p>Mai has applied for special leave to appeal a decision made by the FCFCOA.</p>
                                            <select class="js-q-choice">
                                                <option selected="selected">High Court</option>
                                                <option>Federal Court</option>
                                                <option>Federal Circuit and Family Court</option>
                                            </select>
                                        </div>
                                    </div>
                                    
                                    <!--For use in a set-->
                                    <li class="cont-question" data-question-level="2" data-question-type="alternative">
                                        <div class="cont-question-body">
                                            <p>Mai has applied for special leave to appeal a decision made by the FCFCOA.</p>
                                            <select class="js-q-choice">
                                                <option selected="selected">High Court</option>
                                                <option>Federal Court</option>
                                                <option>Federal Circuit and Family Court</option>
                                            </select>
                                        </div>
                                    </li>
                                `)}
                            </SyntaxHighlighter>
                        </div>
                        <span className='cont-head-d js-pageMarker-viz'>Short answer question</span>
                        <div className="cont-block cont-block-outlined">
                            <div className='cont-block-body'>
                                <div className="cont-block-body">
                                    <div className="cont-question" data-max-mark="2" data-question-type="short-answer">
                                        <div className="cont-question-body">
                                            <p>Short answer question?</p>
                                            <p>Answer: <input type="text"
                                                              onChange={() => {
                                                              }}
                                                              value="Correct answer"/></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <SyntaxHighlighter language="html" style={{}} className={"cont-block-code"}>
                                {beautifyHTML(`
                                    <div class="cont-question" data-max-mark="2" data-question-type="short-answer">
                                        <div class="cont-question-body">
                                            <p>Short answer question?</p>
                                            <p>Answer: <input type="text" value="Correct answer"/></p>
                                        </div>
                                    </div>
                                    
                                    <li class="cont-question" data-max-mark="2" data-question-type="short-answer">
                                        <div class="cont-question-body">
                                            <p>Short answer question?</p>
                                            <p>Answer: <input type="text" value="Correct answer"/></p>
                                        </div>
                                    </li>
                                `)}
                            </SyntaxHighlighter>
                        </div>
                        <span className='cont-head-d js-pageMarker-viz'>Extended response question</span>
                        <div className="cont-block cont-block-outlined">
                            <div className='cont-block-body'>
                                <div className="cont-block-body">
                                    <div className="cont-question" data-max-mark="3" data-use-workspace="true"
                                         data-question-type="extended-response">
                                        <div className="cont-question-body">
                                            <p>Extended response question 1?</p>
                                        </div>
                                        <p className="cont-question-solution">Suggested solution</p>
                                        <p className="cont-question-worked-solution">Detailed worked solution</p>
                                    </div>
                                </div>
                            </div>
                            <SyntaxHighlighter language="html" style={{}} className={"cont-block-code"}>
                                {beautifyHTML(`
                                    <div class="cont-question" data-max-mark="3" data-use-workspace="true" data-question-type="extended-response">
                                        <div class="cont-question-body">
                                            <p>Extended response question 1?</p>
                                        </div>
                                        <p class="cont-question-solution">Suggested solution</p>
                                        <p class="cont-question-worked-solution">Detailed worked solution</p>
                                    </div>
                                    
                                    <li class="cont-question" data-max-mark="3" data-use-workspace="true" data-question-type="extended-response">
                                        <div class="cont-question-body">
                                            <p>Extended response question 1?</p>
                                        </div>
                                        <p class="cont-question-solution">Suggested solution</p>
                                    </li>
                                `)}
                            </SyntaxHighlighter>
                        </div>
                        <APItable data={[
                            {
                                option: 'data-question-type',
                                attr: API_ATTR.DATA,
                                required: true,
                                description: 'multiple-choice|fill-in-the-blank|drag-and-drop|highlight|alternative|short-answer|extended-response|true-false'
                            },
                            {
                                option: 'data-max-mark',
                                attr: API_ATTR.DATA,
                                required: false,
                                description: 'Maximum mark for self assessed questions'
                            },
                            {
                                option: 'data-use-workspace',
                                attr: API_ATTR.DATA,
                                required: false,
                                description: 'Use workspace flag'
                            },
                        ]}/>
                    </div>
                    <span className='cont-head-c js-pageMarker-viz'>How to group questions and sub questions in a set</span>
                    <p>To group one or more questions in quiz/exercise sets or in multi-level questions, each question or question group should be contained in a <strong>&lt;ol class="cont-question-group"&gt;&lt;/ol&gt;</strong> tag.
                    And each question should be contained in a <strong>&lt;li class="cont-question"&gt;&lt;/li&gt;</strong> tag.</p>
                    <div className='js-group-pageMarker'>
                        <span className='cont-head-d js-pageMarker-viz'>Single level questions</span>
                        <div className="cont-block cont-block-outlined">
                            <div className='cont-block-body'>
                                <ol className="cont-question-group" data-auto-mark="true">
                                    <li className="cont-question" data-question-level="3"
                                        data-question-type="multiple-choice">
                                        <div className="cont-question-body">
                                            <p>The idea that an individual evaluates
                                                their
                                                level of health in reference to others or their own level of health at
                                                another time is referred to as:</p>
                                            <ol className="cont-question-options">
                                                <li className=""><input checked="checked" type="radio"/>relative health
                                                </li>
                                                <li className=""><input type="radio"/>dynamic health</li>
                                                <li className=""><input type="radio"/>personal health</li>
                                                <li className=""><input type="radio"/>individual health</li>
                                            </ol>
                                        </div>
                                    </li>
                                    <li className="cont-question" data-question-level="3"
                                        data-question-type="multiple-choice">
                                        <div className="cont-question-body">
                                            <p>The dimensions of health include:</p>
                                            <ol className="cont-question-options">
                                                <li className=""><input type="radio"/>social, emotional, mental,
                                                    biomedical
                                                    and spiritual
                                                </li>
                                                <li className=""><input checked="checked" type="radio"/>social
                                                    emotional,
                                                    mental, physical and spiritual
                                                </li>
                                                <li className=""><input type="radio"/>love, shelter, peace and nutrition
                                                </li>
                                                <li className=""><input type="radio"/>media, income, culture,
                                                    environment
                                                </li>
                                            </ol>
                                        </div>
                                    </li>
                                </ol>
                            </div>
                            <SyntaxHighlighter language="html" style={{}} className={"cont-block-code"}>
                                {beautifyHTML(`
                                    <ol class="cont-question-group" data-auto-mark="true">
                                        <li class="cont-question" data-question-level="3" data-question-type="multiple-choice">
                                            <div class="cont-question-body">
                                                <p>The idea that an individual evaluates their level of health in reference to others or their own level of health at another time is referred to as:</p>
                                                <ol class="cont-question-options">
                                                    <li class=""><input checked="checked" type="radio"/>relative health</li>
                                                    <li class=""><input type="radio"/>dynamic health</li>
                                                    <li class=""><input type="radio"/>personal health</li>
                                                    <li class=""><input type="radio"/>individual health</li>
                                                </ol>
                                            </div>
                                        </li>
                                        <li class="cont-question" data-question-level="3" data-question-type="multiple-choice">
                                            <div class="cont-question-body">
                                                <p>The dimensions of health include:</p>
                                                <ol class="cont-question-options">
                                                    <li class=""><input type="radio"/>social, emotional, mental, biomedical and spiritual</li>
                                                    <li class=""><input checked="checked" type="radio"/>social emotional, mental, physical and spiritual</li>
                                                    <li class=""><input type="radio"/>love, shelter, peace and nutrition</li>
                                                    <li class=""><input type="radio"/>media, income, culture, environment</li>
                                                </ol>
                                            </div>
                                        </li>
                                    </ol>
                                `)}
                            </SyntaxHighlighter>
                        </div>
                        <div className="cont-block cont-block-outlined">
                            <div className='cont-block-body'>
                                <ol className="cont-question-group" data-auto-mark="false">
                                    <li className="cont-question" data-max-mark="1" data-use-workspace="true"
                                        data-question-type="extended-response">
                                        <p className="cont-question-head">Extended response question 1?</p>
                                        <p className="cont-question-body">Question content</p>
                                        <p className="cont-question-solution">Suggested solution</p>
                                    </li>
                                    <li className="cont-question" data-max-mark="1" data-use-workspace="true"
                                        data-question-type="extended-response">
                                        <p className="cont-question-head">Extended response question 2?</p>
                                        <p className="cont-question-body">Question content.</p>
                                        <p className="cont-question-solution">Answers will vary.</p>
                                    </li>
                                </ol>
                            </div>
                            <SyntaxHighlighter language="html" style={{}} className={"cont-block-code"}>
                                {beautifyHTML(`
                                     <ol class="cont-question-group" data-auto-mark="false">
                                        <li class="cont-question" data-max-mark="1" data-use-workspace="true" data-question-type="extended-response">
                                            <p class="cont-question-body">Extended response question 1?</p>
                                            <p class="cont-question-solution">Suggested solution.</p>
                                        </li>
                                        <li class="cont-question" data-max-mark="1" data-use-workspace="true" data-question-type="extended-response">
                                            <p class="cont-question-body">Extended response question 2?</p>
                                            <p class="cont-question-solution">Answers will vary.</p>
                                        </li>
                                    </ol>
                                `)}
                            </SyntaxHighlighter>
                        </div>
                        <APItable data={[
                            {
                                option: 'cont-question-group',
                                attr: API_ATTR.CLASS,
                                required: true,
                                description: 'Core question group class'
                            },
                            {
                                option: 'cont-question',
                                attr: API_ATTR.CLASS,
                                required: true,
                                description: 'Core question class'
                            },
                            {
                                option: 'cont-question-body',
                                attr: API_ATTR.CLASS,
                                required: true,
                                description: 'Question body content'
                            },
                            {
                                option: 'cont-question-solution',
                                attr: API_ATTR.CLASS,
                                required: false,
                                description: 'Question solution'
                            },
                            {
                                option: 'cont-checklist',
                                attr: API_ATTR.CLASS,
                                required: false,
                                description: 'Checklist question group'
                            },
                            {
                                option: 'cont-linked-questions',
                                attr: API_ATTR.CLASS,
                                required: false,
                                description: 'List of question numbers associated with a checklist 1,2,3,...'
                            },
                            {
                                option: 'data-category',
                                attr: API_ATTR.DATA,
                                required: false,
                                description: 'Fundamentals, Applications, Problem-solving, Fluency'
                            },
                            {
                                option: 'data-question-level',
                                attr: API_ATTR.DATA,
                                required: false,
                                description: 'Difficulty level: 1,2, 3, 4'
                            },
                            {
                                option: 'data-working-programs',
                                attr: API_ATTR.DATA,
                                required: false,
                                description: 'setLevel1, setLevel1H, setLevel1T, setLevel2, setLevel2H, setLevel2T, setLevel3, setLevel3H, setLevel3Q, setLevel3T'
                            },
                            {
                                option: 'data-auto-mark',
                                attr: API_ATTR.DATA,
                                required: false,
                                description: 'true if auto-mark questions'
                            },
                            {
                                option: 'data-question-depth',
                                attr: API_ATTR.DATA,
                                required: false,
                                description: 'question, top-group-question, middle-group-question'
                            },
                            {
                                option: 'data-checklist-index',
                                attr: API_ATTR.DATA,
                                required: false,
                                description: 'Index of associated checklist question 1,2,3,...'
                            }
                        ]}/>
                        <span className='cont-head-d js-pageMarker-viz'>Multi-level questions</span>
                        <div className="cont-block cont-block-outlined">
                            <div className='cont-block-body'>
                                <table className="cont-table cont-question-group-info">
                                    <tbody>
                                    <tr>
                                        <th>&#160;</th>
                                        <th>Left column</th>
                                        <th>Middle column</th>
                                        <th>Right column</th>
                                    </tr>
                                    <tr>
                                        <th>Fluency</th>
                                        <td>1–5</td>
                                        <td>1–6</td>
                                        <td>4–6</td>
                                    </tr>
                                    <tr>
                                        <th>Problem-solving</th>
                                        <td>7, 8</td>
                                        <td>7-9</td>
                                        <td>8-10</td>
                                    </tr>
                                    <tr>
                                        <th>Reasoning</th>
                                        <td>11(&#x00BD;)</td>
                                        <td>11(&#x00BD;), 12</td>
                                        <td>11(&#x00BD;), 12, 13</td>
                                    </tr>
                                    <tr>
                                        <th>Enrichment: Other Number Systems</th>
                                        <td>&#x2013;</td>
                                        <td>&#x2013;</td>
                                        <td>14</td>
                                    </tr>
                                    </tbody>
                                </table>
                                <ol className="cont-question-group" data-auto-mark="false">
                                    <li className="cont-question">
                                        <p className="cont-question-head">Extended response question head 1</p>
                                        <ol className="cont-question-group">
                                            <li className="cont-question">
                                                <p className="cont-question-head">Extended response question head 1a</p>
                                                <ol className="cont-question-group">
                                                    <li className="cont-question" data-max-mark="1"
                                                        data-use-workspace="true"
                                                        data-question-type="extended-response">
                                                        <p className="cont-question-body">Extended response question
                                                            1ai?</p>
                                                        <p className="cont-question-solution">Suggested solution</p>
                                                    </li>
                                                    <li className="cont-question" data-max-mark="1"
                                                        data-use-workspace="true"
                                                        data-question-type="extended-response">
                                                        <p className="cont-question-body">Extended response question
                                                            1aii?</p>
                                                        <p className="cont-question-solution">Suggested solution</p>
                                                    </li>
                                                </ol>
                                            </li>
                                            <li className="cont-question" data-max-mark="1" data-use-workspace="true"
                                                data-question-type="extended-response">
                                                <p className="cont-question-body">Extended response question 1b?</p>
                                                <p className="cont-question-solution">Suggested solution</p>
                                            </li>
                                        </ol>
                                    </li>
                                    <li className="cont-question" data-max-mark="1" data-use-workspace="true"
                                        data-question-type="extended-response">
                                        <p className="cont-question-body">Extended response question 2?</p>
                                        <p className="cont-question-solution">Suggested solution</p>
                                    </li>
                                </ol>
                            </div>
                            <SyntaxHighlighter language="html" style={{}} className={"cont-block-code"}>
                                {beautifyHTML(`
                                    <table class="cont-table cont-question-group-info">
                                        <tbody>
                                        <tr>
                                            <th>&#160;</th>
                                            <th>Left column</th>
                                            <th>Middle column</th>
                                            <th>Right column</th>
                                        </tr>
                                        <tr>
                                            <th>Fluency</th>
                                            <td>1–5</td>
                                            <td>1–6</td>
                                            <td>4–6</td>
                                        </tr>
                                        <tr>
                                            <th>Problem-solving</th>
                                            <td>7, 8</td>
                                            <td>7-9</td>
                                            <td>8-10</td>
                                        </tr>
                                        <tr>
                                            <th>Reasoning</th>
                                            <td>11(&#x00BD;)</td>
                                            <td>11(&#x00BD;), 12</td>
                                            <td>11(&#x00BD;), 12, 13</td>
                                        </tr>
                                        <tr>
                                            <th>Enrichment: Other Number Systems</th>
                                            <td>&#x2013;</td>
                                            <td>&#x2013;</td>
                                            <td>14</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                    <ol class="cont-question-group" data-auto-mark="false">
                                        <li class="cont-question" data-working-programs="setLevel2 setLevel3" data-category="reasoning">
                                            <p class="cont-question-head">Extended response question head 1</p>
                                            <ol class="cont-question-group">
                                                <li class="cont-question">
                                                    <p class="cont-question-head">Extended response question head 1a</p>
                                                    <ol class="cont-question-group">
                                                        <li class="cont-question" data-max-mark="1" data-use-workspace="true" data-question-type="extended-response">
                                                            <p class="cont-question-body">Extended response question 1ai?</p>
                                                            <p class="cont-question-solution">Suggested solution</p>
                                                        </li>
                                                        <li class="cont-question" data-max-mark="1" data-use-workspace="true" data-question-type="extended-response">
                                                            <p class="cont-question-body">Extended response question 1aii?</p>
                                                            <p class="cont-question-solution">Suggested solution</p>
                                                        </li>
                                                    </ol>
                                                </li>
                                                <li class="cont-question" data-max-mark="1" data-use-workspace="true" data-question-type="extended-response">
                                                    <p class="cont-question-body">Extended response question 1b?</p>
                                                    <p class="cont-question-solution">Suggested solution</p>
                                                </li>
                                            </ol>
                                        </li>
                                        <li class="cont-question" data-max-mark="1" data-use-workspace="true" data-question-type="extended-response">
                                            <p class="cont-question-body">Extended response question 2?</p>
                                            <p class="cont-question-solution">Suggested solution</p>
                                        </li>
                                    </ol>
                                `)}
                            </SyntaxHighlighter>
                        </div>
                        <APItable data={[
                            {
                                option: 'cont-question-group',
                                attr: API_ATTR.CLASS,
                                required: true,
                                description: 'Core question group class'
                            },
                            {
                                option: 'cont-question',
                                attr: API_ATTR.CLASS,
                                required: true,
                                description: 'Core question class'
                            },
                            {
                                option: 'cont-question-head',
                                attr: API_ATTR.CLASS,
                                required: true,
                                description: 'Question head content'
                            },
                            {
                                option: 'cont-question-group-info',
                                attr: API_ATTR.CLASS,
                                required: false,
                                description: 'Question group info'
                            },
                        ]}/>
                    </div>
                </div>
                <span className='cont-head-b js-pageMarker-viz'>Layouts</span>
                <div className='js-group-pageMarker'>
                    <span className='cont-head-c js-pageMarker-viz'>Examples: solution and explanation</span>
                    You can use columns to create this layout, but use the <b>cont-column-group-nowrap</b> so that in
                    small screen mode the layout won't be affected by wrapping. Columns can be nested for more complex
                    layouts.
                    <div className="cont-block cont-block-outlined">
                        <div className="cont-block-body">
                            <div className="cont-column-group-nowrap">
                                <div className="cont-column-item">
                                    <span className="cont-head-c">SOLUTION</span>
                                </div>
                                <div className="cont-column-item">
                                    <span className="cont-head-c">EXPLANATION</span>
                                </div>
                            </div>
                            <ol className="cont-list-lower-alpha">
                                <li>
                                    <div className="cont-column-group-nowrap">
                                        <div className="cont-column-item">
                                            Solution 1 <br/> over 2 lines ...
                                        </div>
                                        <div className="cont-column-item">
                                            Explanation 1 ...
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div className="cont-column-group-nowrap">
                                        <div className="cont-column-item">
                                            <div className="cont-column-group-nowrap">
                                                <div className="cont-column-item">
                                                    Solution 2 part 1 ...
                                                </div>
                                                <div className="cont-column-item">
                                                    Solution 2 part 2 <br/> over 2 lines ...
                                                </div>
                                            </div>
                                        </div>
                                        <div className="cont-column-item">
                                            Explanation 2 ...
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div className="cont-column-group-nowrap">
                                        <div className="cont-column-item">
                                            Solution 3 ...
                                        </div>
                                        <div className="cont-column-item">
                                            Explanation 3 ...
                                        </div>
                                    </div>
                                </li>
                            </ol>
                        </div>
                        <SyntaxHighlighter language="html" style={{}} className={"cont-block-code"}>
                            {beautifyHTML(`
                            <div class="cont-column-group-nowrap">
                                <div class="cont-column-item">
                                    <span class="cont-head-c">SOLUTION</span>
                                </div>
                                <div class="cont-column-item">
                                    <span class="cont-head-c">EXPLANATION</span>
                                </div>
                            </div>
                            <ol class="cont-list-lower-alpha">
                                <li>
                                    <div class="cont-column-group-nowrap">
                                        <div class="cont-column-item">
                                            Solution 1 <br/> over 2 lines ...
                                        </div>
                                        <div class="cont-column-item">
                                            Explanation 1 ...
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div class="cont-column-group-nowrap">
                                        <div class="cont-column-item">
                                            <div class="cont-column-group-nowrap">
                                                <div class="cont-column-item">
                                                    Solution 2 part 1 ...
                                                </div>
                                                <div class="cont-column-item">
                                                    Solution 2 part 2 <br/> over 2 lines ...
                                                </div>
                                            </div>
                                        </div>
                                        <div class="cont-column-item">
                                            Explanation 2 ...
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div class="cont-column-group-nowrap">
                                        <div class="cont-column-item">
                                            Solution 3 ...
                                        </div>
                                        <div class="cont-column-item">
                                            Explanation 3 ...
                                        </div>
                                    </div>
                                </li>
                            </ol>
                            `)}
                        </SyntaxHighlighter>
                    </div>
                </div>
                <span className='cont-head-b js-pageMarker-viz'>HTML Structure and Guidelines</span>
                <div className='js-group-pageMarker'>
                    <span className='cont-head-c js-pageMarker-viz'>HTML Structure</span>
                    <div className="cont-block cont-block-outlined">
                        <SyntaxHighlighter language="html" style={{}} className={"cont-block-code"}>
                            {beautifyHTML(`
                                <!DOCTYPE html>
                                <html xmlns="http://www.w3.org/1999/xhtml"  xmlns:mathml="http://www.w3.org/1998/Math/MathML">
                                    <head>
                                        <meta charset="UTF-8"/>
                                        <title>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua</title>
                                        <link rel="stylesheet" href="../../css/contentStyles.css" type="text/css" />
                                        <link rel="stylesheet" href="../../css/contentColors.css" type="text/css" />
                                        <link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Open+Sans:400,500,600,700"/>
                                        <script src="../../js/custom.js"></script>
                                        <script id="MathJax-script" async src="https://cdn.jsdelivr.net/npm/mathjax@3/es5/tex-mml-chtml.js"></script>
                                        ...
                                    </head>
                                    <body class="cont-base cont-proof">
                                        <span class="cont-section-head cont-head-a">1 Linear relations</span>
                                        <section class="cont-section">
                                            ...
                                        </section>
                                    </body>
                                </html>
                            `)}
                        </SyntaxHighlighter>
                        <div>
                            <div className='cont-block-body'>
                                <strong>Notes:</strong>
                                <ol>
                                    <li>Include standard HTML Doctype declarations  &lt;!DOCTYPE html&gt;</li>
                                    <li>Only CSS style
                                        sheets <strong>contentStyles.css</strong> and <strong>contentColors.css</strong> should
                                        be included (font styles may be included if needed)
                                    </li>
                                    <li>The &lt;body class="<strong>cont-base cont-proof</strong>"&gt;&lt;/body&gt; tag
                                        should have <i>cont-base</i> and <i>cont-proof</i> classes
                                    </li>
                                    <li>The section title should be in a &lt;div
                                        class="<strong>cont-section-head</strong>"&gt; element and be positioned before
                                        the &lt;div class="<strong>cont-section</strong>"&gt; element.
                                    </li>
                                    <li>All HTML to be imported should be in a &lt;div
                                        class="<strong>cont-section</strong>"&gt; element.
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                    <span className='cont-head-c js-pageMarker-viz'>HTML Guidelines</span>
                    <div className="cont-block cont-block-outlined">
                        <div className='cont-block-body'>
                            <ol>
                                <li>All content must be valid XML and XHTML. Check the content with a XHTML validator
                                    before supplying.
                                </li>
                                <li>The CSS <strong>style</strong> attribute should <strong>not</strong> be used.</li>
                                <li>The <strong>id</strong> attribute should <strong>not</strong> be used.</li>
                                <li>The <strong>&lt;h1&gt;,&lt;h2&gt;,&lt;h3&gt;,&lt;h4&gt;,&lt;h5&gt;</strong> tags
                                    should <strong>not</strong> be used.
                                </li>
                                <li>All content to be imported should be contained inside &lt;div
                                    class="<strong>cont-section</strong>"&gt;&lt;/div&gt;. Before this element, the
                                    section name may be included in a &lt;div
                                    class="<strong>cont-section-head</strong>"&gt;&lt;/div&gt;.
                                </li>
                                <li>The &lt;body class="<strong>cont-base cont-proof</strong>"&gt;&lt;/body&gt; element
                                    include the cont-base and cont-proof CSS classes
                                </li>
                                <li>Only the CSS classes included in <a
                                    href="/users/generalFiles/styles/allowed-content-classes.txt"
                                    target="_blank">allowed-content-classes.txt</a> and described
                                    in <strong>https://www.hotmaths.com.au/public/guide</strong> should be used. If the
                                    supplied CSS classes are not adequate to format the content, let us know and we can
                                    add additional classes as needed.
                                </li>
                                <li>Only the HTML data attributes included in <a
                                    href="/users/generalFiles/styles/allowed-data-attributes.txt"
                                    target="_blank">allowed-data-attributes.txt</a> and described
                                    in <strong>https://www.hotmaths.com.au/public/guide</strong> should be used.
                                </li>
                                <li>Only the following CSS files should be included (font styles may be included if
                                    needed):
                                    <ul>
                                        <li><a href="/users/generalFiles/styles/contentStyles.css"
                                               target="_blank">contentStyles.css</a></li>
                                        <li><a href="/users/generalFiles/styles/contentColors.css"
                                               target="_blank">contentColors.css</a></li>
                                    </ul>
                                </li>
                                <li>All XHTML structures and CSS classes should be consistent and re-used across all
                                    books in a series.
                                </li>
                                <li>Nesting of HTML elements should correctly follow the HTML standard, for example:
                                    <ul>
                                        <li>The &lt;figcaption&gt; element should be inside a &lt;figure&gt; element.
                                        </li>
                                        <li>There should be no elements between consecutive list item
                                            elements &lt;li&gt;&lt;/li&gt;.
                                        </li>
                                    </ul>
                                </li>
                                <li>
                                    Any content within a section that can be toggled between shown and hidden (e.g.
                                    calculator, example sections) must be enclosed within an element with a specific
                                    name or attribute based on the content type. For example:
                                    <ul>
                                        <li><strong>Accordion box</strong> - <i>cont-block-accordion</i>, see
                                            section {getInternalLink('blockAccordion')} of the content style guide
                                        </li>
                                        <li><strong>Example boxes</strong> - <i>cont-interactive-example</i>,
                                            see {getInternalLink('exampleBlock')} of the content style guide
                                        </li>
                                        <li><strong>Toggle
                                            show/hide</strong> - <i>cont-block-toggle</i> and <i>cont-toggle-item</i>,
                                            see section {getInternalLink('showHideContent')} of the content style guide
                                        </li>
                                        <li><strong>Teacher
                                            notes</strong> - <i>cont-block-dialog</i> and <i>cont-teacher-notes</i>, see
                                            section {getInternalLink('teacherNotesDialog')} of the content style guide
                                        </li>
                                        <li><strong>Image zoom</strong> - <i>cont-img-zoom</i>, see
                                            section {getInternalLink('imageZoom')} of the content style guide
                                        </li>
                                        <li><strong>Shortcut link anchor</strong> - <i>cont-shortcut-anchor</i>, see
                                            section {getInternalLink('bHeadAanchor')} of the content style guide
                                        </li>
                                    </ul>
                                </li>
                                <li>Use this Open Sans font &lt;link rel="stylesheet"
                                    href="https://fonts.googleapis.com/css?family=Open+Sans:400,500,600,700"/&gt;</li>
                                <li>Do not include empty content tags, for example <strong>&lt;p&gt;&lt;/p&gt;</strong></li>
                                <li>For formatting maths and equations, only use LaTex compatible with MathJax version 3. Do <b>not</b> use MathML.</li>
                            </ol>
                        </div>
                    </div>
                    <span className='cont-head-c js-pageMarker-viz'>Folder Structure</span>
                    <div className="cont-block cont-block-outlined">
                        <div className='cont-block-body'>
                            <ol>
                                <li>All XHTML files should use the <strong>.xhtml</strong> file name extension</li>
                                <li>
                                    All files that aren't questions, exercises, activities or checklists should be
                                    called section.xhtml.
                                </li>
                                <li>
                                    Only the following <b>XHTML</b> files should be used:
                                    <ol className="cont-list-lower-alpha">
                                        <li>html/chapter_id/section_id/introduction.xhtml</li>
                                        <li>html/chapter_id/section_id/concept-map.xhtml</li>
                                        <li>html/chapter_id/section_id/section.xhtml</li>
                                        <li>html/chapter_id/section_id/activity.xhtml</li>
                                        <li>html/chapter_id/section_id/exercise.xhtml</li>
                                        <li>html/chapter_id/section_id/quiz.xhtml</li>
                                        <li>html/chapter_id/section_id/review.xhtml</li>
                                        <li>html/chapter_id/section_id/data-questions.xhtml</li>
                                        <li>html/chapter_id/section_id/checklist.xhtml</li>
                                        <li>html/chapter_id/section_id/checklist-questions.xhtml (when checklist is
                                            interactive in humanities)
                                        </li>
                                    </ol>
                                </li>
                                <li>
                                    Only the following folders should be used:
                                    <ol className="cont-list-lower-alpha">
                                        <li>html/chapter_id/section_id/</li>
                                        <li>html/chapter_id/images/</li>
                                        <li>html/images/</li>
                                        <li>html/css/</li>
                                        <li>html/js/</li>
                                        <li>media/chapter_id/section_id/</li>
                                        <li>media/worksheet-mapping.csv</li>
                                        <li>media/video-mapping.csv</li>
                                        <li>media/audio-mapping.csv</li>
                                        <li>metadata/</li>
                                    </ol>
                                </li>
                                <li>
                                    <ol className="cont-list-lower-alpha">
                                        <li>The <b>html</b> folder must exist in the base folder</li>
                                        <li>HTML, CSS, javascript and images should be in
                                            the <strong>html</strong> folder
                                        </li>
                                        <li>PDF, Word, Excel, Video, Subtitle and Audio files should be in
                                            the <strong>media</strong> folder
                                        </li>
                                        <li>HTML files should structured
                                            under <strong>html/chapter_id/section_id</strong> folders
                                        </li>
                                        <li>Media files should structured
                                            under <strong>media/chapter_id/section_id</strong> folders
                                        </li>
                                        <li>
                                            Place the CSV files that map media files to their respective names and descriptions in:
                                            <ul>
                                                <li>media/worksheet-mapping.csv</li>
                                                <li>media/video-mapping.csv</li>
                                                <li>media/audio-mapping.csv</li>
                                            </ul>
                                        </li>
                                        <li>
                                            The media mapping CSV file should contain three columns (the description column is optional):
                                            <table className="cont-table">
                                                <tr>
                                                    <th>Column Name</th>
                                                    <th>Column Details</th>
                                                    <th>Example</th>
                                                </tr>
                                                <tr>
                                                    <td>file</td>
                                                    <td>complete file name including file extension</td>
                                                    <td>SCI7VIC2E_QC_0101.pdf</td>
                                                </tr>
                                                <tr>
                                                    <td>name</td>
                                                    <td>worksheet name</td>
                                                    <td>Quick check 1.1</td>
                                                </tr>
                                                <tr>
                                                    <td>description</td>
                                                    <td>worksheet description - optional</td>
                                                    <td>Quick check questions for section</td>
                                                </tr>
                                            </table>
                                            <p>
                                                Example video mapping CSV file: <a href="/users/generalFiles/video-mapping.csv" target="_blank">video-mapping.csv</a>.<br/>
                                                Example worksheet mapping CSV file: <a href="/users/generalFiles/worksheet-mapping.csv" target="_blank">worksheet-mapping.csv</a>.
                                            </p>
                                        </li>
                                    </ol>
                                </li>
                            </ol>
                        </div>
                    </div>
                    <span className='cont-head-c js-pageMarker-viz'>Example Content</span>
                    <div className="cont-block cont-block-outlined">
                        <div className='cont-block-body'>
                            <h4>Science Content</h4>
                            <ul>
                                <li>Section HTML <a href="/users/exampleContent/science/section.xhtml" download>section.xhtml</a>.</li>
                                <li>Review questions HTML file <a href="/users/exampleContent/science/review.xhtml" download>review.xhtml</a>.</li>
                                <li>Data questions HTML file <a href="/users/exampleContent/science/data-questions.xhtml" download>data-questions.xhtml</a>.</li>
                                <li>Diagnostic questions HTML file <a href="/users/exampleContent/science/diagnostic-questions.xhtml" download>diagnostic-questions.xhtml</a>.</li>
                                <li>Custom JS file <a href="/users/exampleContent/custom.js" download>custom.js</a>.</li>
                            </ul>
                            <h4>Maths Content</h4>
                            <ul>
                                <li>Section HTML <a href="/users/exampleContent/maths/section.xhtml" download>section.xhtml</a>.</li>
                                <li>Exercise questions HTML file <a href="/users/exampleContent/maths/exercise.xhtml" download>exercise.xhtml</a>.</li>
                                <li>Custom JS file <a href="/users/exampleContent/custom.js" download>custom.js</a>.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

const beautifyHTML = code => {
    const beautifiedHTML = beautify(code, {
        indent_size: 4,
        brace_style: "expand"
    });
    return beautifiedHTML;
};

const ExampleTable = props => {
    const {className = ''} = props;
    return (
        <table className={'cont-table ' + className}>
            <thead>
            <tr>
                <th scope='col'>#</th>
                <th scope='col'>First Name</th>
                <th scope='col'>Last Name</th>
                <th scope='col'>User Type</th>
                <th scope='col'>Role Access</th>
            </tr>
            </thead>
            <tbody>
            <tr>
                <th scope='row'>1</th>
                <td>Bart</td>
                <td>Simpson</td>
                <td>Student</td>
                <td>
                    <ul>
                        <li>Student</li>
                    </ul>
                </td>
            </tr>
            <tr>
                <th scope='row'>2</th>
                <td>Edna</td>
                <td>Krabappel</td>
                <td rowSpan='2'>Teacher</td>
                <td rowSpan='2'>
                    <ul>
                        <li>Teacher</li>
                        <li>Student</li>
                    </ul>
                </td>
            </tr>
            <tr>
                <th scope='row'>3</th>
                <td>Elizabeth</td>
                <td>Hoover</td>
            </tr>
            <tr>
                <th scope='row'>4</th>
                <td>Seymour</td>
                <td>Skinner</td>
                <td>Teacher Administrator</td>
                <td>
                    <ul>
                        <li>Teacher Admin</li>
                        <li>Teacher</li>
                        <li>Student</li>
                    </ul>
                </td>
            </tr>
            </tbody>
        </table>
    )
}

const ExampleColumnTable = props => {
    const {className = ''} = props;
    return (
        <table className={'cont-table ' + className}>
            <colgroup>
                <col className="cont-width-80"/>
                <col className="cont-width-20"/>
            </colgroup>
            <thead>
            <tr>
                <th scope='col'>Analysis questions</th>
                <th scope='col'>Your response</th>
            </tr>
            </thead>
            <tbody>
            <tr>
                <td>Bart</td>
                <td>Simpson</td>
            </tr>
            <tr>
                <td>Edna</td>
                <td>Krabappel</td>
            </tr>
            <tr>
                <td>Elizabeth</td>
                <td>Hoover</td>
            </tr>
            <tr>
                <td>Seymour</td>
                <td>Skinner</td>
            </tr>
            </tbody>
        </table>
    )
}

const APItable = props => {
    const {data = []} = props;
    const applyTo = data[0].applyTo;
    const replacement = data[0].replacement;
    return (
        <table className={'cont-table cont-table-basic'}>
            <thead>
            <tr>
                <th>Option</th>
                <th>Attribute</th>
                {replacement && (
                    <th>Replacement</th>
                )}
                {applyTo && (
                    <th>Apply to</th>
                )}
                <th>Required</th>
                <th>Description</th>
            </tr>
            </thead>
            <tbody>
            {data.map((obj, i) => {
                return (
                    <tr key={i}>
                        <td>{obj.option}</td>
                        <td>{obj.attr}</td>
                        {obj.replacement &&
                            <td>{obj.replacement}</td>
                        }
                        {applyTo && (
                            <td>{obj.applyTo}</td>
                        )}
                        <td>{obj.required ? 'Required' : 'Optional'}</td>
                        <td>{obj.description}</td>
                    </tr>
                )
            })}
            </tbody>
        </table>
    )
}

const ExampleBlockBodySmall = props => {
    return (
        <div className='cont-block-body'>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et
                dolore magna aliqua.</p>
        </div>
    )
}

export const ExampleBlockBody = props => {
    return (
        <div className='cont-block-body'>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et
                dolore magna aliqua. Urna duis convallis convallis tellus id interdum velit laoreet.</p>
            <ol>
                <li>Item 1</li>
                <li>Item 2
                    <ul>
                        <li>Sub item 1</li>
                    </ul>
                </li>
            </ol>
            <hr/>
            <p className='cont-emph'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                incididunt ut labore et dolore magna aliqua.</p>
            <table className={'cont-table cont-table-basic'}>
                <thead>
                <tr>
                    <th scope='col'>First Name</th>
                    <th scope='col'>Last Name</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>Bart</td>
                    <td>Simpson</td>
                </tr>
                </tbody>
            </table>
        </div>
    )
}

export default LessonContentStyleGuide;